// Auto-generated by backend/generate_account_ui.py — auth extras + Dukung Manasik labels (11 languages).
export const ACCOUNT_UI = {
  "rememberMe": {
    "id": "Ingat saya",
    "en": "Remember me",
    "ar": "تذكّرني",
    "fr": "Se souvenir de moi",
    "de": "Angemeldet bleiben",
    "es": "Recuérdame",
    "ru": "Запомнить меня",
    "zh": "记住我",
    "ja": "ログイン状態を保持する",
    "ko": "로그인 상태 유지",
    "hi": "मुझे याद रखें"
  },
  "rememberHint": {
    "id": "Tetap masuk selama 30 hari di perangkat ini",
    "en": "Stay signed in for 30 days on this device",
    "ar": "ابقَ مسجّلاً للدخول لمدة 30 يومًا على هذا الجهاز",
    "fr": "Rester connecté pendant 30 jours sur cet appareil",
    "de": "Auf diesem Gerät 30 Tage lang angemeldet bleiben",
    "es": "Permanecer conectado durante 30 días en este dispositivo",
    "ru": "Оставаться в системе 30 дней на этом устройстве",
    "zh": "在此设备上保持登录状态 30 天",
    "ja": "このデバイスで30日間ログイン状態を維持する",
    "ko": "이 기기에서 30일 동안 로그인 상태 유지",
    "hi": "इस डिवाइस पर 30 दिनों तक साइन इन रहें"
  },
  "googleLogin": {
    "id": "Masuk dengan Google",
    "en": "Sign in with Google",
    "ar": "تسجيل الدخول بحساب Google",
    "fr": "Se connecter avec Google",
    "de": "Mit Google anmelden",
    "es": "Iniciar sesión con Google",
    "ru": "Войти через Google",
    "zh": "使用 Google 登录",
    "ja": "Google でログイン",
    "ko": "Google로 로그인",
    "hi": "Google से साइन इन करें"
  },
  "orDivider": {
    "id": "atau",
    "en": "or",
    "ar": "أو",
    "fr": "ou",
    "de": "oder",
    "es": "o",
    "ru": "или",
    "zh": "或",
    "ja": "または",
    "ko": "또는",
    "hi": "या"
  },
  "googleFailed": {
    "id": "Masuk dengan Google gagal. Silakan coba lagi.",
    "en": "Sign in with Google failed. Please try again.",
    "ar": "فشل تسجيل الدخول بحساب Google. يرجى المحاولة مرة أخرى.",
    "fr": "La connexion avec Google a échoué. Veuillez réessayer.",
    "de": "Anmeldung mit Google fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "es": "Error al iniciar sesión con Google. Por favor, inténtelo de nuevo.",
    "ru": "Не удалось войти через Google. Пожалуйста, попробуйте ещё раз.",
    "zh": "使用 Google 登录失败，请重试。",
    "ja": "Google でのログインに失敗しました。もう一度お試しください。",
    "ko": "Google 로그인에 실패했습니다. 다시 시도해 주세요.",
    "hi": "Google से साइन इन विफल हुआ। कृपया पुनः प्रयास करें।"
  },
  "googleSigningIn": {
    "id": "Menyelesaikan masuk dengan Google…",
    "en": "Completing sign in with Google…",
    "ar": "جارٍ إتمام تسجيل الدخول بحساب Google…",
    "fr": "Finalisation de la connexion avec Google…",
    "de": "Anmeldung mit Google wird abgeschlossen…",
    "es": "Completando el inicio de sesión con Google…",
    "ru": "Завершение входа через Google…",
    "zh": "正在完成 Google 登录…",
    "ja": "Google ログインを完了しています…",
    "ko": "Google 로그인을 완료하는 중…",
    "hi": "Google से साइन इन पूरा हो रहा है…"
  },
  "googleLinked": {
    "id": "Terhubung dengan Google",
    "en": "Connected with Google",
    "ar": "مرتبط بحساب Google",
    "fr": "Connecté avec Google",
    "de": "Mit Google verbunden",
    "es": "Conectado con Google",
    "ru": "Привязано к Google",
    "zh": "已连接Google账户",
    "ja": "Googleと連携済み",
    "ko": "Google에 연결됨",
    "hi": "Google से जुड़ा हुआ"
  },
  "strengthLabel": {
    "id": "Kekuatan kata sandi",
    "en": "Password strength",
    "ar": "قوة كلمة المرور",
    "fr": "Force du mot de passe",
    "de": "Passwortstärke",
    "es": "Fortaleza de la contraseña",
    "ru": "Надёжность пароля",
    "zh": "密码强度",
    "ja": "パスワードの強度",
    "ko": "비밀번호 강도",
    "hi": "पासवर्ड की मजबूती"
  },
  "strengthWeak": {
    "id": "Lemah",
    "en": "Weak",
    "ar": "ضعيف",
    "fr": "Faible",
    "de": "Schwach",
    "es": "Débil",
    "ru": "Слабый",
    "zh": "弱",
    "ja": "弱い",
    "ko": "약함",
    "hi": "कमज़ोर"
  },
  "strengthFair": {
    "id": "Sedang",
    "en": "Fair",
    "ar": "متوسط",
    "fr": "Moyen",
    "de": "Mittel",
    "es": "Regular",
    "ru": "Средний",
    "zh": "一般",
    "ja": "普通",
    "ko": "보통",
    "hi": "सामान्य"
  },
  "strengthGood": {
    "id": "Kuat",
    "en": "Strong",
    "ar": "قوي",
    "fr": "Fort",
    "de": "Stark",
    "es": "Fuerte",
    "ru": "Надёжный",
    "zh": "强",
    "ja": "強い",
    "ko": "강함",
    "hi": "मजबूत"
  },
  "strengthStrong": {
    "id": "Sangat kuat",
    "en": "Very strong",
    "ar": "قوي جداً",
    "fr": "Très fort",
    "de": "Sehr stark",
    "es": "Muy fuerte",
    "ru": "Очень надёжный",
    "zh": "非常强",
    "ja": "非常に強い",
    "ko": "매우 강함",
    "hi": "बहुत मजबूत"
  },
  "strengthTip": {
    "id": "Gunakan 8+ karakter dengan huruf besar, huruf kecil, angka, dan simbol.",
    "en": "Use 8+ characters with uppercase, lowercase, numbers, and symbols.",
    "ar": "استخدم 8 أحرف أو أكثر تشمل أحرفاً كبيرة وصغيرة وأرقاماً ورموزاً.",
    "fr": "Utilisez 8 caractères ou plus avec des majuscules, minuscules, chiffres et symboles.",
    "de": "Verwenden Sie 8+ Zeichen mit Groß- und Kleinbuchstaben, Zahlen und Symbolen.",
    "es": "Use 8+ caracteres con mayúsculas, minúsculas, números y símbolos.",
    "ru": "Используйте 8+ символов: заглавные, строчные буквы, цифры и специальные символы.",
    "zh": "使用8个或以上字符，包含大写字母、小写字母、数字和符号。",
    "ja": "大文字・小文字・数字・記号を含む8文字以上を使用してください。",
    "ko": "대문자, 소문자, 숫자, 기호를 포함한 8자 이상을 사용하세요.",
    "hi": "8 या अधिक वर्ण उपयोग करें जिनमें बड़े अक्षर, छोटे अक्षर, संख्याएँ और प्रतीक शामिल हों।"
  },
  "setPassword": {
    "id": "Buat kata sandi",
    "en": "Create a password",
    "ar": "إنشاء كلمة مرور",
    "fr": "Créer un mot de passe",
    "de": "Passwort erstellen",
    "es": "Crear una contraseña",
    "ru": "Создать пароль",
    "zh": "创建密码",
    "ja": "パスワードを作成する",
    "ko": "비밀번호 만들기",
    "hi": "पासवर्ड बनाएँ"
  },
  "setPasswordHint": {
    "id": "Akun Anda masuk lewat Google. Buat kata sandi agar bisa masuk dengan email juga.",
    "en": "Your account is signed in via Google. Create a password so you can also sign in with your email.",
    "ar": "حسابك مسجَّل الدخول عبر Google. أنشئ كلمة مرور حتى تتمكن أيضاً من تسجيل الدخول بالبريد الإلكتروني.",
    "fr": "Votre compte est connecté via Google. Créez un mot de passe pour pouvoir également vous connecter avec votre e-mail.",
    "de": "Ihr Konto ist über Google angemeldet. Erstellen Sie ein Passwort, damit Sie sich auch mit Ihrer E-Mail-Adresse anmelden können.",
    "es": "Su cuenta está vinculada a Google. Cree una contraseña para poder iniciar sesión también con su correo electrónico.",
    "ru": "Ваш аккаунт привязан через Google. Создайте пароль, чтобы также входить с помощью электронной почты.",
    "zh": "您的账户通过 Google 登录。创建密码后，您也可以使用电子邮件登录。",
    "ja": "あなたのアカウントはGoogleでサインインしています。メールアドレスでもサインインできるようにパスワードを作成してください。",
    "ko": "계정이 Google을 통해 로그인되어 있습니다. 이메일로도 로그인할 수 있도록 비밀번호를 만드세요.",
    "hi": "आपका खाता Google के माध्यम से साइन इन है। पासवर्ड बनाएँ ताकि आप ईमेल से भी साइन इन कर सकें।"
  },
  "noPasswordDelete": {
    "id": "Akun Anda masuk lewat Google, jadi tidak perlu kata sandi.",
    "en": "Your account is signed in via Google, so no password is needed.",
    "ar": "حسابك مسجَّل الدخول عبر Google، لذا لا حاجة إلى كلمة مرور.",
    "fr": "Votre compte est connecté via Google, donc aucun mot de passe n'est nécessaire.",
    "de": "Ihr Konto ist über Google angemeldet, daher wird kein Passwort benötigt.",
    "es": "Su cuenta está vinculada a Google, por lo que no se necesita contraseña.",
    "ru": "Ваш аккаунт привязан через Google, поэтому пароль не требуется.",
    "zh": "您的账户通过 Google 登录，因此无需密码。",
    "ja": "あなたのアカウントはGoogleでサインインしているため、パスワードは必要ありません。",
    "ko": "계정이 Google을 통해 로그인되어 있으므로 비밀번호가 필요하지 않습니다.",
    "hi": "आपका खाता Google के माध्यम से साइन इन है, इसलिए पासवर्ड की आवश्यकता नहीं है।"
  },
  "supportTitle": {
    "id": "Dukung Manasik",
    "en": "Support Manasik",
    "ar": "ادعم تطبيق مناسك",
    "fr": "Soutenir Manasik",
    "de": "Manasik unterstützen",
    "es": "Apoyar a Manasik",
    "ru": "Поддержать Manasik",
    "zh": "支持 Manasik",
    "ja": "Manasikを支援する",
    "ko": "Manasik 후원하기",
    "hi": "Manasik को सहयोग करें"
  },
  "supportSubtitle": {
    "id": "Semua fitur Manasik tetap gratis untuk seluruh jamaah. Dukungan seikhlasnya Anda membantu biaya server, audio doa, dan pengembangan — tanpa iklan, selamanya.",
    "en": "All Manasik features remain free for all pilgrims. Your voluntary support helps cover server costs, prayer audio, and development — no ads, forever.",
    "ar": "جميع ميزات المناسك تبقى مجانيةً لكافة الحجاج والمعتمرين. دعمك الطوعي يُساهم في تغطية تكاليف الخوادم والتسجيلات الصوتية للأدعية والتطوير — بلا إعلانات، إلى الأبد.",
    "fr": "Toutes les fonctionnalités de Manasik restent gratuites pour tous les pèlerins. Votre soutien volontaire aide à couvrir les frais de serveur, les audios de prières et le développement — sans publicités, pour toujours.",
    "de": "Alle Manasik-Funktionen bleiben für alle Pilger kostenlos. Ihre freiwillige Unterstützung hilft bei der Deckung von Serverkosten, Gebetsaudio und Entwicklung — ohne Werbung, für immer.",
    "es": "Todas las funciones de Manasik siguen siendo gratuitas para todos los peregrinos. Tu apoyo voluntario ayuda a cubrir los costos del servidor, el audio de oraciones y el desarrollo — sin anuncios, para siempre.",
    "ru": "Все функции Manasik остаются бесплатными для всех паломников. Ваша добровольная поддержка помогает покрывать расходы на сервер, аудио молитв и разработку — без рекламы, навсегда.",
    "zh": "Manasik的所有功能对所有朝圣者永久免费。您的自愿支持有助于支付服务器费用、祈祷音频和开发费用——永远无广告。",
    "ja": "Manasikのすべての機能はすべての巡礼者に無料のままです。皆様の自発的なご支援は、サーバー費用、祈りの音声、開発費用の賄いに役立ちます — 広告なし、永遠に。",
    "ko": "Manasik의 모든 기능은 모든 순례자에게 계속 무료로 제공됩니다. 여러분의 자발적인 후원은 서버 비용, 기도 오디오 및 개발을 지원합니다 — 광고 없이, 영원히.",
    "hi": "Manasik की सभी सुविधाएँ सभी हाजियों के लिए निःशुल्क रहती हैं। आपका स्वैच्छिक सहयोग सर्वर लागत, दुआ ऑडियो और विकास में मदद करता है — बिना विज्ञापन के, हमेशा के लिए।"
  },
  "supporterBadge": {
    "id": "Pendukung",
    "en": "Supporter",
    "ar": "داعم",
    "fr": "Supporter",
    "de": "Unterstützer",
    "es": "Patrocinador",
    "ru": "Сторонник",
    "zh": "支持者",
    "ja": "サポーター",
    "ko": "후원자",
    "hi": "समर्थक"
  },
  "demoBadge": {
    "id": "Mode demo",
    "en": "Demo Mode",
    "ar": "وضع تجريبي",
    "fr": "Mode démo",
    "de": "Demo-Modus",
    "es": "Modo demo",
    "ru": "Демо-режим",
    "zh": "演示模式",
    "ja": "デモモード",
    "ko": "데모 모드",
    "hi": "डेमो मोड"
  },
  "demoNote": {
    "id": "Pembayaran sedang disimulasikan (mode demo) — tidak ada tagihan nyata. Pembayaran asli aktif setelah RevenueCat dikonfigurasi.",
    "en": "Payment is being simulated (demo mode) — no real charges apply. Real payments will be active once RevenueCat is configured.",
    "ar": "الدفع يعمل في وضع المحاكاة (وضع تجريبي) — لا توجد رسوم حقيقية. ستُفعَّل المدفوعات الحقيقية بعد ضبط إعدادات RevenueCat.",
    "fr": "Le paiement est simulé (mode démo) — aucun frais réel n'est appliqué. Les paiements réels seront activés une fois RevenueCat configuré.",
    "de": "Die Zahlung wird simuliert (Demo-Modus) — es fallen keine echten Gebühren an. Echte Zahlungen werden aktiviert, sobald RevenueCat konfiguriert ist.",
    "es": "El pago está siendo simulado (modo demo) — no se aplican cargos reales. Los pagos reales estarán activos una vez que RevenueCat esté configurado.",
    "ru": "Оплата выполняется в режиме симуляции (демо-режим) — реальные списания не производятся. Реальные платежи будут активированы после настройки RevenueCat.",
    "zh": "支付正在模拟中（演示模式）——不会产生真实费用。配置 RevenueCat 后，真实支付将会激活。",
    "ja": "支払いはシミュレーション中です（デモモード）— 実際の請求は発生しません。RevenueCat が設定されると、実際の支払いが有効になります。",
    "ko": "결제가 시뮬레이션 중입니다 (데모 모드) — 실제 청구는 발생하지 않습니다. RevenueCat이 구성되면 실제 결제가 활성화됩니다.",
    "hi": "भुगतान का अनुकरण किया जा रहा है (डेमो मोड) — कोई वास्तविक शुल्क नहीं लगेगा। RevenueCat कॉन्फ़िगर होने के बाद वास्तविक भुगतान सक्रिय होगा।"
  },
  "planMonthly": {
    "id": "Bulanan",
    "en": "Monthly",
    "ar": "شهري",
    "fr": "Mensuel",
    "de": "Monatlich",
    "es": "Mensual",
    "ru": "Ежемесячный",
    "zh": "每月",
    "ja": "月額",
    "ko": "월간",
    "hi": "मासिक"
  },
  "planYearly": {
    "id": "Tahunan",
    "en": "Yearly",
    "ar": "سنوي",
    "fr": "Annuel",
    "de": "Jährlich",
    "es": "Anual",
    "ru": "Ежегодный",
    "zh": "每年",
    "ja": "年額",
    "ko": "연간",
    "hi": "वार्षिक"
  },
  "planLifetime": {
    "id": "Seumur hidup",
    "en": "Lifetime",
    "ar": "مدى الحياة",
    "fr": "À vie",
    "de": "Lebenslang",
    "es": "De por vida",
    "ru": "Пожизненный",
    "zh": "终身",
    "ja": "買い切り",
    "ko": "평생",
    "hi": "आजीवन"
  },
  "perMonth": {
    "id": "/ bulan",
    "en": "/ month",
    "ar": "/ شهر",
    "fr": "/ mois",
    "de": "/ Monat",
    "es": "/ mes",
    "ru": "/ месяц",
    "zh": "/ 月",
    "ja": "/ 月",
    "ko": "/ 월",
    "hi": "/ माह"
  },
  "perYear": {
    "id": "/ tahun",
    "en": "/ year",
    "ar": "/ سنة",
    "fr": "/ an",
    "de": "/ Jahr",
    "es": "/ año",
    "ru": "/ год",
    "zh": "/ 年",
    "ja": "/ 年",
    "ko": "/ 년",
    "hi": "/ वर्ष"
  },
  "payOnce": {
    "id": "sekali bayar",
    "en": "One-time payment",
    "ar": "دفعة واحدة",
    "fr": "Paiement unique",
    "de": "Einmalige Zahlung",
    "es": "Pago único",
    "ru": "Единовременная оплата",
    "zh": "一次性付款",
    "ja": "一回払い",
    "ko": "일회 결제",
    "hi": "एकमुश्त भुगतान"
  },
  "savePct": {
    "id": "Hemat {pct}%",
    "en": "Save {pct}%",
    "ar": "وفّر {pct}%",
    "fr": "Économisez {pct}%",
    "de": "Spare {pct}%",
    "es": "Ahorra {pct}%",
    "ru": "Сэкономьте {pct}%",
    "zh": "节省 {pct}%",
    "ja": "{pct}% お得",
    "ko": "{pct}% 절약",
    "hi": "{pct}% बचाएं"
  },
  "popular": {
    "id": "Paling populer",
    "en": "Most popular",
    "ar": "الأكثر شعبية",
    "fr": "Le plus populaire",
    "de": "Am beliebtesten",
    "es": "Más popular",
    "ru": "Самый популярный",
    "zh": "最受欢迎",
    "ja": "最も人気",
    "ko": "가장 인기 있는",
    "hi": "सबसे लोकप्रिय"
  },
  "choosePlan": {
    "id": "Pilih paket",
    "en": "Choose a plan",
    "ar": "اختر الباقة",
    "fr": "Choisir un forfait",
    "de": "Paket wählen",
    "es": "Elegir un plan",
    "ru": "Выбрать тариф",
    "zh": "选择套餐",
    "ja": "プランを選ぶ",
    "ko": "요금제 선택",
    "hi": "योजना चुनें"
  },
  "processing": {
    "id": "Memproses…",
    "en": "Processing…",
    "ar": "جارٍ المعالجة…",
    "fr": "Traitement en cours…",
    "de": "Verarbeitung…",
    "es": "Procesando…",
    "ru": "Обработка…",
    "zh": "处理中…",
    "ja": "処理中…",
    "ko": "처리 중…",
    "hi": "प्रसंस्करण…"
  },
  "benefitsTitle": {
    "id": "Yang Anda dapatkan",
    "en": "What you get",
    "ar": "ما ستحصل عليه",
    "fr": "Ce que vous obtenez",
    "de": "Was Sie erhalten",
    "es": "Lo que obtienes",
    "ru": "Что вы получаете",
    "zh": "您将获得",
    "ja": "特典内容",
    "ko": "혜택 내용",
    "hi": "आपको क्या मिलेगा"
  },
  "benefit1": {
    "id": "Lencana Pendukung di profil Anda",
    "en": "Supporter Badge on your profile",
    "ar": "شارة الداعم على ملفك الشخصي",
    "fr": "Badge Supporter sur votre profil",
    "de": "Unterstützer-Abzeichen in Ihrem Profil",
    "es": "Insignia de Patrocinador en tu perfil",
    "ru": "Значок Сторонника в вашем профиле",
    "zh": "您的个人资料上显示支持者徽章",
    "ja": "プロフィールにサポーターバッジを表示",
    "ko": "프로필에 서포터 배지 표시",
    "hi": "आपकी प्रोफ़ाइल पर सपोर्टर बैज"
  },
  "benefit2": {
    "id": "Ikut menjaga Manasik gratis & tanpa iklan untuk semua jamaah",
    "en": "Help keep Manasik free and ad-free for all pilgrims",
    "ar": "المساهمة في إبقاء تطبيق المناسك مجانياً وخالياً من الإعلانات لجميع الحجاج والمعتمرين",
    "fr": "Contribuer à garder Manasik gratuit et sans publicité pour tous les pèlerins",
    "de": "Dazu beitragen, Manasik für alle Pilger kostenlos und werbefrei zu halten",
    "es": "Ayudar a mantener Manasik gratuito y sin anuncios para todos los peregrinos",
    "ru": "Помочь сохранить Manasik бесплатным и без рекламы для всех паломников",
    "zh": "帮助为所有朝觐者保持Manasik免费且无广告",
    "ja": "すべての巡礼者のためにManasikを無料・広告なしで維持することに貢献",
    "ko": "모든 순례자를 위해 Manasik을 무료·광고 없이 유지하는 데 기여",
    "hi": "सभी हाजियों के लिए Manasik को मुफ़्त और विज्ञापन-मुक्त रखने में सहायता"
  },
  "benefit3": {
    "id": "Mendukung audio doa, terjemahan 11 bahasa, dan fitur baru",
    "en": "Support audio du'a, translations in 11 languages, and new features",
    "ar": "دعم ميزة الصوت للأدعية، والترجمات بـ11 لغة، والميزات الجديدة",
    "fr": "Soutenir l'audio des invocations, les traductions en 11 langues et les nouvelles fonctionnalités",
    "de": "Unterstützung von Dua-Audio, Übersetzungen in 11 Sprachen und neuen Funktionen",
    "es": "Apoyar el audio de du'as, traducciones en 11 idiomas y nuevas funciones",
    "ru": "Поддержка аудио ду'а, переводов на 11 языков и новых функций",
    "zh": "支持祈祷音频、11种语言翻译及新功能",
    "ja": "ドゥアーの音声、11言語の翻訳、および新機能をサポート",
    "ko": "두아 오디오, 11개 언어 번역 및 새로운 기능 지원",
    "hi": "दु'आ ऑडियो, 11 भाषाओं में अनुवाद और नई सुविधाओं का समर्थन"
  },
  "benefit4": {
    "id": "Doa kami untuk keberkahan Anda dan keluarga",
    "en": "Our du'a for your blessings and your family's",
    "ar": "دعاؤنا لكم بالبركة لكم ولأسرتكم",
    "fr": "Notre invocation pour vos bénédictions et celles de votre famille",
    "de": "Unser Du'a für Ihren Segen und den Ihrer Familie",
    "es": "Nuestra du'a por las bendiciones para usted y su familia",
    "ru": "Наш ду'а о благословении для вас и вашей семьи",
    "zh": "我们为您和您的家人祈求祝福",
    "ja": "あなたとご家族へのバラカのためのドゥアー",
    "ko": "귀하와 가족을 위한 두아와 축복",
    "hi": "आपके और आपके परिवार की बरकत के लिए हमारी दु'आ"
  },
  "thanksTitle": {
    "id": "Terima kasih, {name}!",
    "en": "Thank you, {name}!",
    "ar": "شكراً لك، {name}!",
    "fr": "Merci, {name} !",
    "de": "Danke, {name}!",
    "es": "¡Gracias, {name}!",
    "ru": "Спасибо, {name}!",
    "zh": "感谢您，{name}！",
    "ja": "ありがとうございます、{name}！",
    "ko": "감사합니다, {name}!",
    "hi": "शुक्रिया, {name}!"
  },
  "thanksBody": {
    "id": "Anda adalah Pendukung Manasik. Semoga Allah membalas kebaikan Anda dengan berlipat ganda.",
    "en": "You are a Manasik Supporter. May Allah reward your kindness manifold.",
    "ar": "أنتَ داعمٌ لتطبيق المناسك. جزاك الله خيراً وضاعف لك الأجر والمثوبة.",
    "fr": "Vous êtes un Soutien Manasik. Qu'Allah récompense votre générosité au centuple.",
    "de": "Sie sind ein Manasik-Unterstützer. Möge Allah Ihre Güte vielfach belohnen.",
    "es": "Eres un Patrocinador de Manasik. Que Allah recompense tu bondad multiplicada.",
    "ru": "Вы являетесь Сторонником Манасик. Да воздаст вам Аллах за вашу доброту многократно.",
    "zh": "您是Manasik的支持者。愿安拉成倍地回报您的善举。",
    "ja": "あなたはManasikのサポーターです。アッラーがあなたの善意を幾重にも報いてくださいますように。",
    "ko": "당신은 Manasik 후원자입니다. 알라께서 당신의 선행을 몇 배로 보상해 주시길 바랍니다.",
    "hi": "आप Manasik के समर्थक हैं। अल्लाह आपकी भलाई का कई गुना बदला दे।"
  },
  "activePlan": {
    "id": "Paket aktif: {plan}",
    "en": "Active plan: {plan}",
    "ar": "الباقة النشطة: {plan}",
    "fr": "Abonnement actif : {plan}",
    "de": "Aktiver Plan: {plan}",
    "es": "Plan activo: {plan}",
    "ru": "Активный план: {plan}",
    "zh": "当前套餐：{plan}",
    "ja": "有効なプラン：{plan}",
    "ko": "활성 플랜: {plan}",
    "hi": "सक्रिय योजना: {plan}"
  },
  "since": {
    "id": "Sejak {date}",
    "en": "Since {date}",
    "ar": "منذ {date}",
    "fr": "Depuis le {date}",
    "de": "Seit {date}",
    "es": "Desde el {date}",
    "ru": "С {date}",
    "zh": "自 {date} 起",
    "ja": "{date} より",
    "ko": "{date} 부터",
    "hi": "{date} से"
  },
  "until": {
    "id": "Berlaku hingga {date}",
    "en": "Valid until {date}",
    "ar": "صالح حتى {date}",
    "fr": "Valable jusqu'au {date}",
    "de": "Gültig bis {date}",
    "es": "Válido hasta el {date}",
    "ru": "Действует до {date}",
    "zh": "有效期至 {date}",
    "ja": "{date} まで有効",
    "ko": "{date} 까지 유효",
    "hi": "{date} तक वैध"
  },
  "lifetimeNote": {
    "id": "Berlaku seumur hidup",
    "en": "Valid for a lifetime",
    "ar": "صالح مدى الحياة",
    "fr": "Valable à vie",
    "de": "Lebenslang gültig",
    "es": "Válido de por vida",
    "ru": "Действует пожизненно",
    "zh": "终身有效",
    "ja": "生涯有効",
    "ko": "평생 유효",
    "hi": "जीवन भर के लिए वैध"
  },
  "cancelDemo": {
    "id": "Batalkan (demo)",
    "en": "Cancel (demo)",
    "ar": "إلغاء (تجريبي)",
    "fr": "Annuler (démo)",
    "de": "Abbrechen (Demo)",
    "es": "Cancelar (demo)",
    "ru": "Отмена (демо)",
    "zh": "取消（演示）",
    "ja": "キャンセル（デモ）",
    "ko": "취소 (데모)",
    "hi": "रद्द करें (डेमो)"
  },
  "purchaseSuccess": {
    "id": "Alhamdulillah, dukungan Anda berhasil!",
    "en": "Alhamdulillah, your support was successful!",
    "ar": "الحمد لله، دعمك تمّ بنجاح!",
    "fr": "Alhamdulillah, votre soutien a été effectué avec succès !",
    "de": "Alhamdulillah, Ihre Unterstützung war erfolgreich!",
    "es": "Alhamdulillah, ¡tu apoyo fue exitoso!",
    "ru": "Альхамдулиллях, ваша поддержка прошла успешно!",
    "zh": "感谢真主，您的支持已成功！",
    "ja": "アルハムドゥリッラー、サポートが完了しました！",
    "ko": "알함두릴라, 후원이 성공적으로 완료되었습니다!",
    "hi": "अलहम्दुलिल्लाह, आपका समर्थन सफल रहा!"
  },
  "purchaseFailed": {
    "id": "Pembayaran tidak berhasil atau dibatalkan.",
    "en": "Payment was unsuccessful or cancelled.",
    "ar": "لم تتم عملية الدفع أو تمّ إلغاؤها.",
    "fr": "Le paiement a échoué ou a été annulé.",
    "de": "Die Zahlung war nicht erfolgreich oder wurde abgebrochen.",
    "es": "El pago no fue exitoso o fue cancelado.",
    "ru": "Оплата не прошла или была отменена.",
    "zh": "付款未成功或已取消。",
    "ja": "お支払いが完了しなかったか、キャンセルされました。",
    "ko": "결제가 실패하였거나 취소되었습니다.",
    "hi": "भुगतान सफल नहीं हुआ या रद्द कर दिया गया।"
  },
  "plansUnavailable": {
    "id": "Paket belum dapat dimuat. Silakan coba lagi nanti.",
    "en": "Plans could not be loaded. Please try again later.",
    "ar": "تعذّر تحميل الباقات. يرجى المحاولة مرة أخرى لاحقاً.",
    "fr": "Les forfaits n'ont pas pu être chargés. Veuillez réessayer plus tard.",
    "de": "Pakete konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
    "es": "Los planes no pudieron cargarse. Por favor, inténtelo de nuevo más tarde.",
    "ru": "Не удалось загрузить пакеты. Пожалуйста, попробуйте позже.",
    "zh": "套餐暂时无法加载，请稍后再试。",
    "ja": "プランを読み込めませんでした。後でもう一度お試しください。",
    "ko": "요금제를 불러올 수 없습니다. 나중에 다시 시도해 주세요.",
    "hi": "योजनाएँ लोड नहीं हो सकीं। कृपया बाद में पुनः प्रयास करें।"
  },
  "homeTitle": {
    "id": "Dukung Manasik agar tetap gratis",
    "en": "Support Manasik to keep it free",
    "ar": "ادعم تطبيق مناسك ليبقى مجاناً",
    "fr": "Soutenez Manasik pour qu'il reste gratuit",
    "de": "Unterstützen Sie Manasik, damit es kostenlos bleibt",
    "es": "Apoya Manasik para que siga siendo gratuito",
    "ru": "Поддержите Manasik, чтобы он оставался бесплатным",
    "zh": "支持 Manasik，让它永远免费",
    "ja": "Manasikを無料のまま維持するためにサポートを",
    "ko": "Manasik을 무료로 유지하기 위해 후원해 주세요",
    "hi": "Manasik को मुफ़्त बनाए रखने के लिए समर्थन करें"
  },
  "homeHint": {
    "id": "Seikhlasnya · dapatkan lencana Pendukung 1 tahun",
    "en": "Voluntary · receive a Supporter badge for 1 year",
    "ar": "تبرع طوعي · احصل على شارة الداعم لمدة سنة كاملة",
    "fr": "Volontaire · recevez un badge Supporter pour 1 an",
    "de": "Freiwillig · erhalten Sie ein Unterstützer-Abzeichen für 1 Jahr",
    "es": "Voluntario · obtén una insignia de Colaborador por 1 año",
    "ru": "Добровольно · получите значок Сторонника на 1 год",
    "zh": "随心捐助 · 获得1年支持者徽章",
    "ja": "任意寄付 · 1年間のサポーターバッジを受け取る",
    "ko": "자발적 후원 · 1년간 서포터 배지 획득",
    "hi": "स्वैच्छिक · 1 वर्ष के लिए समर्थक बैज प्राप्त करें"
  },
  "homeCta": {
    "id": "Dukung",
    "en": "Support",
    "ar": "ادعم",
    "fr": "Soutenir",
    "de": "Unterstützen",
    "es": "Apoyar",
    "ru": "Поддержать",
    "zh": "支持",
    "ja": "サポート",
    "ko": "지원하기",
    "hi": "समर्थन करें"
  },
  "secureNote": {
    "id": "Pembayaran aman diproses oleh Midtrans atau PayPal — data kartu Anda tidak pernah tersimpan di Manasik.",
    "en": "Payments are securely processed by Midtrans or PayPal — your card data is never stored in Manasik.",
    "ar": "تتم معالجة المدفوعات بأمان عبر Midtrans أو PayPal — لا يتم تخزين بيانات بطاقتك أبدًا في Manasik.",
    "fr": "Les paiements sont traités en toute sécurité par Midtrans ou PayPal — vos données de carte ne sont jamais stockées dans Manasik.",
    "de": "Zahlungen werden sicher über Midtrans oder PayPal abgewickelt — Ihre Kartendaten werden niemals in Manasik gespeichert.",
    "es": "Los pagos son procesados de forma segura por Midtrans o PayPal — los datos de su tarjeta nunca se almacenan en Manasik.",
    "ru": "Платежи надёжно обрабатываются через Midtrans или PayPal — данные вашей карты никогда не сохраняются в Manasik.",
    "zh": "付款由 Midtrans 或 PayPal 安全处理——您的卡片数据绝不会存储在 Manasik 中。",
    "ja": "お支払いは Midtrans または PayPal によって安全に処理されます。カードデータは Manasik に保存されることはありません。",
    "ko": "결제는 Midtrans 또는 PayPal을 통해 안전하게 처리됩니다 — 귀하의 카드 정보는 Manasik에 저장되지 않습니다.",
    "hi": "भुगतान Midtrans या PayPal द्वारा सुरक्षित रूप से संसाधित किया जाता है — आपका कार्ड डेटा कभी भी Manasik में संग्रहीत नहीं होता।"
  },
  "freeNote": {
    "id": "Semua fitur tetap gratis, dengan atau tanpa dukungan.",
    "en": "All features remain free, with or without support.",
    "ar": "جميع الميزات تبقى مجانية، سواء قدّمت دعمًا أم لا.",
    "fr": "Toutes les fonctionnalités restent gratuites, avec ou sans soutien.",
    "de": "Alle Funktionen bleiben kostenlos, mit oder ohne Unterstützung.",
    "es": "Todas las funciones siguen siendo gratuitas, con o sin apoyo.",
    "ru": "Все функции остаются бесплатными, с поддержкой или без.",
    "zh": "无论是否提供支持，所有功能均保持免费。",
    "ja": "サポートの有無にかかわらず、すべての機能は無料のままです。",
    "ko": "지원 여부에 관계없이 모든 기능은 무료로 유지됩니다.",
    "hi": "समर्थन के साथ या बिना, सभी सुविधाएँ निःशुल्क रहती हैं।"
  },
  "donateTitle": {
    "id": "Dukung seikhlasnya",
    "en": "Support voluntarily",
    "ar": "ادعم طوعاً",
    "fr": "Soutenir volontairement",
    "de": "Freiwillig unterstützen",
    "es": "Apoyar voluntariamente",
    "ru": "Поддержать добровольно",
    "zh": "自愿支持",
    "ja": "任意でサポートする",
    "ko": "자발적으로 후원하기",
    "hi": "स्वेच्छा से सहयोग करें"
  },
  "donateSubtitle": {
    "id": "Pilih nominal atau isi sendiri. Setiap dukungan memberi Anda lencana Pendukung selama 1 tahun.",
    "en": "Choose an amount or enter your own. Every contribution gives you a Supporter badge for 1 year.",
    "ar": "اختر المبلغ أو أدخل مبلغاً مخصصاً. كل مساهمة تمنحك شارة الداعم لمدة سنة كاملة.",
    "fr": "Choisissez un montant ou saisissez le vôtre. Chaque contribution vous offre un badge Supporter pendant 1 an.",
    "de": "Wählen Sie einen Betrag oder geben Sie Ihren eigenen ein. Jeder Beitrag gibt Ihnen ein Unterstützer-Abzeichen für 1 Jahr.",
    "es": "Elige un monto o ingresa el tuyo. Cada contribución te otorga una insignia de Colaborador por 1 año.",
    "ru": "Выберите сумму или введите свою. Каждый взнос даёт вам значок Сторонника на 1 год.",
    "zh": "选择金额或自行输入。每一笔捐助都将为您提供1年的支持者徽章。",
    "ja": "金額を選択するか、自分で入力してください。すべての寄付に対して1年間のサポーターバッジが付与されます。",
    "ko": "금액을 선택하거나 직접 입력하세요. 모든 후원에는 1년간의 서포터 배지가 제공됩니다.",
    "hi": "कोई राशि चुनें या अपनी राशि दर्ज करें। हर योगदान आपको 1 वर्ष के लिए समर्थक बैज देता है।"
  },
  "customAmount": {
    "id": "Nominal lain",
    "en": "Other amount",
    "ar": "مبلغ آخر",
    "fr": "Autre montant",
    "de": "Anderer Betrag",
    "es": "Otro monto",
    "ru": "Другая сумма",
    "zh": "其他金额",
    "ja": "その他の金額",
    "ko": "다른 금액",
    "hi": "अन्य राशि"
  },
  "donateNow": {
    "id": "Dukung sekarang",
    "en": "Support Now",
    "ar": "ادعم الآن",
    "fr": "Soutenir maintenant",
    "de": "Jetzt unterstützen",
    "es": "Apoyar ahora",
    "ru": "Поддержать сейчас",
    "zh": "立即支持",
    "ja": "今すぐサポート",
    "ko": "지금 지원하기",
    "hi": "अभी समर्थन करें"
  },
  "minAmount": {
    "id": "Minimal {min}",
    "en": "Minimum {min}",
    "ar": "الحد الأدنى {min}",
    "fr": "Minimum {min}",
    "de": "Mindestbetrag {min}",
    "es": "Mínimo {min}",
    "ru": "Минимум {min}",
    "zh": "最低 {min}",
    "ja": "最低 {min}",
    "ko": "최소 {min}",
    "hi": "न्यूनतम {min}"
  },
  "payMethods": {
    "id": "QRIS · GoPay · CC",
    "en": "QRIS · GoPay · CC",
    "ar": "QRIS · GoPay · CC",
    "fr": "QRIS · GoPay · CC",
    "de": "QRIS · GoPay · CC",
    "es": "QRIS · GoPay · CC",
    "ru": "QRIS · GoPay · CC",
    "zh": "QRIS · GoPay · CC",
    "ja": "QRIS · GoPay · CC",
    "ko": "QRIS · GoPay · CC",
    "hi": "QRIS · GoPay · CC"
  },
  "pendingNote": {
    "id": "Menunggu konfirmasi pembayaran…",
    "en": "Awaiting payment confirmation…",
    "ar": "في انتظار تأكيد الدفع…",
    "fr": "En attente de confirmation du paiement…",
    "de": "Warte auf Zahlungsbestätigung…",
    "es": "Esperando confirmación de pago…",
    "ru": "Ожидание подтверждения оплаты…",
    "zh": "等待付款确认…",
    "ja": "支払い確認を待っています…",
    "ko": "결제 확인 대기 중…",
    "hi": "भुगतान की पुष्टि की प्रतीक्षा में…"
  },
  "paymentPending": {
    "id": "Pembayaran belum selesai. Selesaikan pembayaran Anda, lalu cek status.",
    "en": "Payment not yet complete. Please complete your payment, then check the status.",
    "ar": "لم يكتمل الدفع بعد. يرجى إتمام الدفع ثم التحقق من الحالة.",
    "fr": "Le paiement n'est pas encore finalisé. Veuillez finaliser votre paiement, puis vérifier le statut.",
    "de": "Zahlung noch nicht abgeschlossen. Bitte schließen Sie Ihre Zahlung ab und überprüfen Sie dann den Status.",
    "es": "El pago aún no está completo. Complete su pago y luego verifique el estado.",
    "ru": "Оплата ещё не завершена. Пожалуйста, завершите оплату и проверьте статус.",
    "zh": "付款尚未完成。请完成付款，然后查看状态。",
    "ja": "支払いがまだ完了していません。支払いを完了してから、ステータスを確認してください。",
    "ko": "결제가 아직 완료되지 않았습니다. 결제를 완료한 후 상태를 확인하세요.",
    "hi": "भुगतान अभी पूरा नहीं हुआ है। कृपया अपना भुगतान पूरा करें, फिर स्थिति जांचें।"
  },
  "checkStatus": {
    "id": "Cek status pembayaran",
    "en": "Check Payment Status",
    "ar": "تحقق من حالة الدفع",
    "fr": "Vérifier le statut du paiement",
    "de": "Zahlungsstatus prüfen",
    "es": "Verificar estado de pago",
    "ru": "Проверить статус оплаты",
    "zh": "查看付款状态",
    "ja": "支払いステータスを確認する",
    "ko": "결제 상태 확인",
    "hi": "भुगतान स्थिति जांचें"
  },
  "paymentFailedStatus": {
    "id": "Pembayaran {status}. Silakan coba lagi.",
    "en": "Payment {status}. Please try again.",
    "ar": "الدفع {status}. يرجى المحاولة مرة أخرى.",
    "fr": "Paiement {status}. Veuillez réessayer.",
    "de": "Zahlung {status}. Bitte versuchen Sie es erneut.",
    "es": "Pago {status}. Por favor, inténtelo de nuevo.",
    "ru": "Платёж {status}. Пожалуйста, попробуйте ещё раз.",
    "zh": "付款{status}。请重试。",
    "ja": "支払い{status}。もう一度お試しください。",
    "ko": "결제 {status}. 다시 시도해 주세요.",
    "hi": "भुगतान {status}। कृपया पुनः प्रयास करें।"
  },
  "totalDonated": {
    "id": "Total dukungan Anda: {amount}",
    "en": "Your total support: {amount}",
    "ar": "إجمالي دعمك: {amount}",
    "fr": "Votre soutien total : {amount}",
    "de": "Ihre Gesamtunterstützung: {amount}",
    "es": "Tu apoyo total: {amount}",
    "ru": "Ваша общая поддержка: {amount}",
    "zh": "您的总支持金额：{amount}",
    "ja": "あなたの総サポート額：{amount}",
    "ko": "총 후원 금액: {amount}",
    "hi": "आपका कुल समर्थन: {amount}"
  },
  "planDonation": {
    "id": "Donasi",
    "en": "Donation",
    "ar": "تبرع",
    "fr": "Don",
    "de": "Spende",
    "es": "Donación",
    "ru": "Пожертвование",
    "zh": "捐款",
    "ja": "寄付",
    "ko": "기부",
    "hi": "दान"
  },
  "paymentsDisabled": {
    "id": "Pembayaran belum tersedia saat ini.",
    "en": "Payments are not available at this time.",
    "ar": "المدفوعات غير متاحة في الوقت الحالي.",
    "fr": "Les paiements ne sont pas disponibles pour le moment.",
    "de": "Zahlungen sind derzeit nicht verfügbar.",
    "es": "Los pagos no están disponibles en este momento.",
    "ru": "Платежи в настоящее время недоступны.",
    "zh": "当前暂不支持付款。",
    "ja": "現在、支払いはご利用いただけません。",
    "ko": "현재 결제를 사용할 수 없습니다.",
    "hi": "इस समय भुगतान उपलब्ध नहीं है।"
  },
  "manageHint": {
    "id": "Bukti pembayaran dikirim oleh penyedia pembayaran (Midtrans, PayPal, atau aplikasi e-wallet Anda) ke e-mail/aplikasi Anda.",
    "en": "Payment proof is sent by the payment provider (Midtrans, PayPal, or your e-wallet app) to your e-mail or app.",
    "ar": "يتم إرسال إثبات الدفع من قِبَل مزود الدفع (Midtrans أو PayPal أو تطبيق المحفظة الإلكترونية الخاص بك) إلى بريدك الإلكتروني أو تطبيقك.",
    "fr": "La preuve de paiement est envoyée par le fournisseur de paiement (Midtrans, PayPal ou votre application e-wallet) à votre e-mail ou application.",
    "de": "Der Zahlungsnachweis wird vom Zahlungsanbieter (Midtrans, PayPal oder Ihrer E-Wallet-App) an Ihre E-Mail-Adresse oder App gesendet.",
    "es": "El comprobante de pago es enviado por el proveedor de pago (Midtrans, PayPal o su aplicación de monedero electrónico) a su correo electrónico o aplicación.",
    "ru": "Подтверждение оплаты отправляется платёжным провайдером (Midtrans, PayPal или вашим приложением электронного кошелька) на вашу электронную почту или в приложение.",
    "zh": "付款凭证由支付提供商（Midtrans、PayPal 或您的电子钱包应用）发送至您的电子邮件或应用程序。",
    "ja": "支払い証明は、決済プロバイダー（Midtrans、PayPal、またはご利用の電子ウォレットアプリ）からお客様のメールまたはアプリに送信されます。",
    "ko": "결제 증명은 결제 제공업체(Midtrans, PayPal 또는 귀하의 전자지갑 앱)에서 귀하의 이메일 또는 앱으로 전송됩니다.",
    "hi": "भुगतान का प्रमाण भुगतान प्रदाता (Midtrans, PayPal, या आपके ई-वॉलेट ऐप) द्वारा आपके ई-मेल या ऐप पर भेजा जाता है।"
  },
  "payMethodTitle": {
    "id": "Pilih metode pembayaran",
    "en": "Choose a payment method",
    "ar": "اختر طريقة الدفع",
    "fr": "Choisissez un mode de paiement",
    "de": "Zahlungsmethode auswählen",
    "es": "Elige un método de pago",
    "ru": "Выберите способ оплаты",
    "zh": "选择付款方式",
    "ja": "お支払い方法を選択してください",
    "ko": "결제 수단을 선택하세요",
    "hi": "भुगतान विधि चुनें"
  },
  "methodMidtrans": {
    "id": "Indonesia",
    "en": "Indonesia",
    "ar": "إندونيسيا",
    "fr": "Indonésie",
    "de": "Indonesien",
    "es": "Indonesia",
    "ru": "Индонезия",
    "zh": "印度尼西亚",
    "ja": "インドネシア",
    "ko": "인도네시아",
    "hi": "इंडोनेशिया"
  },
  "methodMidtransHint": {
    "id": "QRIS, GoPay & CC",
    "en": "QRIS, GoPay & CC",
    "ar": "QRIS, GoPay & CC",
    "fr": "QRIS, GoPay & CC",
    "de": "QRIS, GoPay & CC",
    "es": "QRIS, GoPay & CC",
    "ru": "QRIS, GoPay & CC",
    "zh": "QRIS, GoPay & CC",
    "ja": "QRIS, GoPay & CC",
    "ko": "QRIS, GoPay & CC",
    "hi": "QRIS, GoPay & CC"
  },
  "methodEwallet": {
    "id": "E-Wallet",
    "en": "E-Wallet",
    "ar": "المحفظة الإلكترونية",
    "fr": "E-Wallet",
    "de": "E-Wallet",
    "es": "Monedero electrónico",
    "ru": "Электронный кошелёк",
    "zh": "电子钱包",
    "ja": "e-ウォレット",
    "ko": "e-지갑",
    "hi": "ई-वॉलेट"
  },
  "methodEwalletHint": {
    "id": "GoPay, OVO, DANA, LinkAja · transfer ke nomor",
    "en": "GoPay, OVO, DANA, LinkAja · transfer to number",
    "ar": "GoPay أو OVO أو DANA أو LinkAja · تحويل إلى الرقم",
    "fr": "GoPay, OVO, DANA, LinkAja · transfert vers le numéro",
    "de": "GoPay, OVO, DANA, LinkAja · Überweisung an Nummer",
    "es": "GoPay, OVO, DANA, LinkAja · transferencia al número",
    "ru": "GoPay, OVO, DANA, LinkAja · перевод на номер",
    "zh": "GoPay、OVO、DANA、LinkAja · 转账至号码",
    "ja": "GoPay、OVO、DANA、LinkAja · 番号へ送金",
    "ko": "GoPay, OVO, DANA, LinkAja · 번호로 이체",
    "hi": "GoPay, OVO, DANA, LinkAja · नंबर पर ट्रांसफर"
  },
  "methodPaypal": {
    "id": "PayPal",
    "en": "PayPal",
    "ar": "PayPal",
    "fr": "PayPal",
    "de": "PayPal",
    "es": "PayPal",
    "ru": "PayPal",
    "zh": "PayPal",
    "ja": "PayPal",
    "ko": "PayPal",
    "hi": "PayPal"
  },
  "methodPaypalHint": {
    "id": "Internasional · USD, EUR, GBP",
    "en": "International · USD, EUR, GBP",
    "ar": "دولي · USD، EUR، GBP",
    "fr": "International · USD, EUR, GBP",
    "de": "International · USD, EUR, GBP",
    "es": "Internacional · USD, EUR, GBP",
    "ru": "Международный · USD, EUR, GBP",
    "zh": "国际 · USD、EUR、GBP",
    "ja": "国際 · USD、EUR、GBP",
    "ko": "국제 · USD, EUR, GBP",
    "hi": "अंतर्राष्ट्रीय · USD, EUR, GBP"
  },
  "noMethods": {
    "id": "Belum ada metode pembayaran yang tersedia.",
    "en": "No payment methods are available yet.",
    "ar": "لا توجد طرق دفع متاحة حتى الآن.",
    "fr": "Aucune méthode de paiement n'est disponible pour le moment.",
    "de": "Es sind noch keine Zahlungsmethoden verfügbar.",
    "es": "Aún no hay métodos de pago disponibles.",
    "ru": "Способы оплаты пока недоступны.",
    "zh": "暂无可用的支付方式。",
    "ja": "現在利用可能な支払い方法はありません。",
    "ko": "아직 사용 가능한 결제 수단이 없습니다.",
    "hi": "अभी कोई भुगतान विधि उपलब्ध नहीं है।"
  },
  "ewalletTitle": {
    "id": "Dukung lewat E-Wallet",
    "en": "Support via E-Wallet",
    "ar": "الدعم عبر المحفظة الإلكترونية",
    "fr": "Soutenir via E-Wallet",
    "de": "Unterstützung per E-Wallet",
    "es": "Apoyar mediante monedero electrónico",
    "ru": "Поддержка через электронный кошелёк",
    "zh": "通过电子钱包支持",
    "ja": "e-ウォレットでサポート",
    "ko": "e-지갑으로 지원하기",
    "hi": "ई-वॉलेट के माध्यम से समर्थन करें"
  },
  "ewalletSubtitle": {
    "id": "Transfer langsung dari GoPay, OVO, DANA, atau LinkAja ke nomor di bawah (biasanya tanpa biaya), lalu kirim konfirmasi agar lencana Pendukung diaktifkan setelah diverifikasi.",
    "en": "Transfer directly from GoPay, OVO, DANA, or LinkAja to the number below (usually free of charge), then send confirmation so that the Supporter badge is activated after verification.",
    "ar": "حوِّل مباشرةً من GoPay أو OVO أو DANA أو LinkAja إلى الرقم أدناه (عادةً بدون رسوم)، ثم أرسل تأكيداً لتفعيل شارة المؤيد بعد التحقق.",
    "fr": "Transférez directement depuis GoPay, OVO, DANA ou LinkAja vers le numéro ci-dessous (généralement sans frais), puis envoyez une confirmation afin que le badge Supporter soit activé après vérification.",
    "de": "Überweisen Sie direkt von GoPay, OVO, DANA oder LinkAja an die unten stehende Nummer (in der Regel kostenlos), und senden Sie anschließend eine Bestätigung, damit das Unterstützer-Abzeichen nach der Überprüfung aktiviert wird.",
    "es": "Transfiera directamente desde GoPay, OVO, DANA o LinkAja al número indicado abajo (generalmente sin cargo), luego envíe una confirmación para que la insignia de Colaborador se active tras la verificación.",
    "ru": "Переведите напрямую с GoPay, OVO, DANA или LinkAja на указанный ниже номер (как правило, бесплатно), затем отправьте подтверждение, чтобы значок Сторонника был активирован после проверки.",
    "zh": "直接从 GoPay、OVO、DANA 或 LinkAja 转账至下方号码（通常免手续费），然后发送确认信息，以便在验证后激活支持者徽章。",
    "ja": "GoPay、OVO、DANA、またはLinkAjaから以下の番号へ直接送金し（通常手数料無料）、確認をお送りください。確認後にサポーターバッジが有効化されます。",
    "ko": "GoPay, OVO, DANA 또는 LinkAja에서 아래 번호로 직접 이체하고(보통 수수료 없음), 확인 메시지를 보내시면 검증 후 서포터 배지가 활성화됩니다.",
    "hi": "GoPay, OVO, DANA, या LinkAja से नीचे दिए गए नंबर पर सीधे ट्रांसफर करें (आमतौर पर बिना शुल्क के), फिर पुष्टि भेजें ताकि सत्यापन के बाद Supporter बैज सक्रिय हो जाए।"
  },
  "ewalletPick": {
    "id": "Pilih dompet yang Anda pakai",
    "en": "Choose the wallet you use",
    "ar": "اختر المحفظة التي تستخدمها",
    "fr": "Choisissez le portefeuille que vous utilisez",
    "de": "Wählen Sie das Wallet, das Sie verwenden",
    "es": "Elija el monedero que utiliza",
    "ru": "Выберите кошелёк, которым вы пользуетесь",
    "zh": "选择您使用的钱包",
    "ja": "ご利用のウォレットを選択してください",
    "ko": "사용하시는 지갑을 선택하세요",
    "hi": "वह वॉलेट चुनें जिसका आप उपयोग करते हैं"
  },
  "ewalletNumber": {
    "id": "Nomor tujuan transfer",
    "en": "Transfer destination number",
    "ar": "رقم حساب التحويل",
    "fr": "Numéro de destination du transfert",
    "de": "Überweisungsziel-Nummer",
    "es": "Número de destino de transferencia",
    "ru": "Номер назначения перевода",
    "zh": "转账目标号码",
    "ja": "振込先番号",
    "ko": "이체 대상 번호",
    "hi": "ट्रांसफर गंतव्य नंबर"
  },
  "ewalletCopy": {
    "id": "Salin nomor",
    "en": "Copy number",
    "ar": "نسخ الرقم",
    "fr": "Copier le numéro",
    "de": "Nummer kopieren",
    "es": "Copiar número",
    "ru": "Скопировать номер",
    "zh": "复制号码",
    "ja": "番号をコピー",
    "ko": "번호 복사",
    "hi": "नंबर कॉपी करें"
  },
  "ewalletCopied": {
    "id": "Nomor tujuan disalin.",
    "en": "Destination number copied.",
    "ar": "تم نسخ رقم الحساب.",
    "fr": "Numéro de destination copié.",
    "de": "Zielnummer kopiert.",
    "es": "Número de destino copiado.",
    "ru": "Номер назначения скопирован.",
    "zh": "目标号码已复制。",
    "ja": "宛先番号をコピーしました。",
    "ko": "대상 번호가 복사되었습니다.",
    "hi": "गंतव्य नंबर कॉपी किया गया।"
  },
  "ewalletStep1": {
    "id": "Buka aplikasi {wallet} → pilih Transfer/Kirim ke nomor ponsel.",
    "en": "Open the {wallet} app → select Transfer/Send to mobile number.",
    "ar": "افتح تطبيق {wallet} ← اختر تحويل/إرسال إلى رقم الهاتف المحمول.",
    "fr": "Ouvrez l'application {wallet} → sélectionnez Transfert/Envoyer vers un numéro de mobile.",
    "de": "Öffnen Sie die {wallet}-App → wählen Sie Überweisung/Senden an Mobilnummer.",
    "es": "Abre la aplicación {wallet} → selecciona Transferir/Enviar a número de móvil.",
    "ru": "Откройте приложение {wallet} → выберите Перевод/Отправить на номер телефона.",
    "zh": "打开 {wallet} 应用 → 选择转账/发送至手机号码。",
    "ja": "{wallet} アプリを開く → 振込/携帯番号へ送金を選択する。",
    "ko": "{wallet} 앱을 열고 → 휴대폰 번호로 이체/보내기를 선택하세요.",
    "hi": "{wallet} ऐप खोलें → मोबाइल नंबर पर ट्रांसफर/भेजें चुनें।"
  },
  "ewalletStep2": {
    "id": "Masukkan nomor {number}, periksa nama penerima yang tampil, lalu kirim nominal dukungan Anda.",
    "en": "Enter the number {number}, verify the recipient name displayed, then send your support amount.",
    "ar": "أدخل الرقم {number}، تحقق من اسم المستلم الظاهر، ثم أرسل مبلغ دعمك.",
    "fr": "Saisissez le numéro {number}, vérifiez le nom du destinataire affiché, puis envoyez votre montant de soutien.",
    "de": "Geben Sie die Nummer {number} ein, überprüfen Sie den angezeigten Empfängernamen und senden Sie dann Ihren Unterstützungsbetrag.",
    "es": "Ingresa el número {number}, verifica el nombre del destinatario que aparece, luego envía tu monto de apoyo.",
    "ru": "Введите номер {number}, проверьте отображаемое имя получателя, затем отправьте сумму поддержки.",
    "zh": "输入号码 {number}，核实显示的收款人姓名，然后发送您的支持金额。",
    "ja": "番号 {number} を入力し、表示された受取人名を確認してから、サポート金額を送金してください。",
    "ko": "번호 {number}를 입력하고, 표시된 수신자 이름을 확인한 후 지원 금액을 보내세요.",
    "hi": "नंबर {number} दर्ज करें, प्रदर्शित प्राप्तकर्ता का नाम जांचें, फिर अपनी सहायता राशि भेजें।"
  },
  "ewalletStep3": {
    "id": "Kembali ke sini dan kirim konfirmasi (dompet, nominal, tanggal). Admin memverifikasi dalam 1–3 hari kerja.",
    "en": "Return here and send a confirmation (e-wallet, amount, date). Admin will verify within 1–3 working days.",
    "ar": "عد إلى هنا وأرسل تأكيداً (المحفظة، المبلغ، التاريخ). سيتحقق المسؤول خلال 1–3 أيام عمل.",
    "fr": "Revenez ici et envoyez une confirmation (portefeuille, montant, date). L'administrateur vérifiera dans 1 à 3 jours ouvrables.",
    "de": "Kehren Sie hierher zurück und senden Sie eine Bestätigung (Wallet, Betrag, Datum). Der Administrator prüft dies innerhalb von 1–3 Werktagen.",
    "es": "Regresa aquí y envía una confirmación (monedero, monto, fecha). El administrador verificará en 1–3 días hábiles.",
    "ru": "Вернитесь сюда и отправьте подтверждение (кошелёк, сумма, дата). Администратор проверит в течение 1–3 рабочих дней.",
    "zh": "返回此处并发送确认信息（电子钱包、金额、日期）。管理员将在 1–3 个工作日内核实。",
    "ja": "ここに戻り、確認情報（電子ウォレット、金額、日付）を送信してください。管理者が1〜3営業日以内に確認します。",
    "ko": "여기로 돌아와 확인 정보(전자지갑, 금액, 날짜)를 보내주세요. 관리자가 1–3 영업일 이내에 확인합니다.",
    "hi": "यहाँ वापस आएं और एक पुष्टि भेजें (ई-वॉलेट, राशि, तारीख)। व्यवस्थापक 1–3 कार्य दिवसों में सत्यापित करेगा।"
  },
  "ewalletNote": {
    "id": "Nama penerima akan tampil di aplikasi dompet Anda sebelum Anda mengonfirmasi transfer. Simpan bukti transfer sampai lencana aktif.",
    "en": "The recipient's name will appear in your wallet app before you confirm the transfer. Keep the transfer receipt until the badge is active.",
    "ar": "سيظهر اسم المستلم في تطبيق المحفظة الخاص بك قبل تأكيد التحويل. احتفظ بإيصال التحويل حتى يصبح الشارة نشطة.",
    "fr": "Le nom du destinataire apparaîtra dans votre application de portefeuille avant de confirmer le virement. Conservez le reçu de virement jusqu'à ce que le badge soit actif.",
    "de": "Der Name des Empfängers wird in Ihrer Wallet-App angezeigt, bevor Sie die Überweisung bestätigen. Bewahren Sie den Überweisungsbeleg auf, bis das Abzeichen aktiv ist.",
    "es": "El nombre del destinatario aparecerá en su aplicación de billetera antes de confirmar la transferencia. Guarde el comprobante de transferencia hasta que la insignia esté activa.",
    "ru": "Имя получателя появится в вашем приложении кошелька до подтверждения перевода. Сохраняйте квитанцию о переводе до активации значка.",
    "zh": "在您确认转账之前，收款人姓名将显示在您的钱包应用中。请保留转账凭证，直到徽章激活为止。",
    "ja": "送金を確認する前に、受取人の名前がウォレットアプリに表示されます。バッジが有効になるまで送金明細を保管してください。",
    "ko": "이체를 확인하기 전에 수신자 이름이 지갑 앱에 표시됩니다. 배지가 활성화될 때까지 이체 영수증을 보관하세요.",
    "hi": "स्थानांतरण की पुष्टि करने से पहले प्राप्तकर्ता का नाम आपके वॉलेट ऐप में दिखाई देगा। बैज सक्रिय होने तक स्थानांतरण की रसीद सुरक्षित रखें।"
  },
  "ewalletReferencePlaceholder": {
    "id": "mis. nama pengirim atau ID transaksi di aplikasi dompet",
    "en": "e.g. sender's name or transaction ID in the wallet app",
    "ar": "مثل: اسم المرسل أو رقم معرّف المعاملة في تطبيق المحفظة",
    "fr": "ex. nom de l'expéditeur ou identifiant de transaction dans l'application de portefeuille",
    "de": "z. B. Name des Absenders oder Transaktions-ID in der Wallet-App",
    "es": "p. ej. nombre del remitente o ID de transacción en la aplicación de billetera",
    "ru": "напр. имя отправителя или идентификатор транзакции в приложении кошелька",
    "zh": "例如：钱包应用中的发送人姓名或交易ID",
    "ja": "例：ウォレットアプリ内の送信者名またはトランザクションID",
    "ko": "예: 지갑 앱의 보내는 사람 이름 또는 거래 ID",
    "hi": "उदा. वॉलेट ऐप में प्रेषक का नाम या लेनदेन आईडी"
  },
  "walletLabel": {
    "id": "Dompet",
    "en": "Wallet",
    "ar": "المحفظة",
    "fr": "Portefeuille",
    "de": "Wallet",
    "es": "Billetera",
    "ru": "Кошелёк",
    "zh": "钱包",
    "ja": "ウォレット",
    "ko": "지갑",
    "hi": "वॉलेट"
  },
  "proofLabel": {
    "id": "Bukti transfer (opsional)",
    "en": "Transfer proof (optional)",
    "ar": "إثبات التحويل (اختياري)",
    "fr": "Preuve de virement (optionnel)",
    "de": "Überweisungsnachweis (optional)",
    "es": "Comprobante de transferencia (opcional)",
    "ru": "Подтверждение перевода (необязательно)",
    "zh": "转账凭证（可选）",
    "ja": "振込証明（任意）",
    "ko": "이체 증명 (선택 사항)",
    "hi": "ट्रांसफर प्रमाण (वैकल्पिक)"
  },
  "proofHint": {
    "id": "Tangkapan layar transfer dari aplikasi dompet/PayPal — JPG, PNG, atau WebP, maks. 8 MB. Mempercepat verifikasi.",
    "en": "Screenshot of the transfer from your wallet app or PayPal — JPG, PNG, or WebP, max. 8 MB. Speeds up verification.",
    "ar": "لقطة شاشة للتحويل من تطبيق المحفظة أو PayPal — بصيغة JPG أو PNG أو WebP، بحجم أقصاه 8 ميغابايت. يُسرِّع عملية التحقق.",
    "fr": "Capture d'écran du virement depuis votre application de portefeuille ou PayPal — JPG, PNG ou WebP, 8 Mo max. Accélère la vérification.",
    "de": "Screenshot der Überweisung aus Ihrer Wallet-App oder PayPal — JPG, PNG oder WebP, max. 8 MB. Beschleunigt die Verifizierung.",
    "es": "Captura de pantalla de la transferencia desde su aplicación de monedero o PayPal — JPG, PNG o WebP, máx. 8 MB. Acelera la verificación.",
    "ru": "Снимок экрана перевода из приложения кошелька или PayPal — JPG, PNG или WebP, макс. 8 МБ. Ускоряет проверку.",
    "zh": "从您的钱包应用或 PayPal 转账的截图 — JPG、PNG 或 WebP，最大 8 MB。有助于加快验证速度。",
    "ja": "ウォレットアプリまたは PayPal からの送金スクリーンショット — JPG、PNG、または WebP、最大 8 MB。確認作業を迅速化します。",
    "ko": "지갑 앱 또는 PayPal에서 이체한 스크린샷 — JPG, PNG 또는 WebP, 최대 8 MB. 확인 절차를 신속하게 합니다.",
    "hi": "अपने वॉलेट ऐप या PayPal से ट्रांसफर का स्क्रीनशॉट — JPG, PNG, या WebP, अधिकतम 8 MB। सत्यापन को तेज़ करता है।"
  },
  "proofUpload": {
    "id": "Unggah bukti",
    "en": "Upload proof",
    "ar": "رفع الإثبات",
    "fr": "Téléverser le justificatif",
    "de": "Nachweis hochladen",
    "es": "Subir comprobante",
    "ru": "Загрузить подтверждение",
    "zh": "上传凭证",
    "ja": "証明をアップロード",
    "ko": "증명 업로드",
    "hi": "प्रमाण अपलोड करें"
  },
  "proofChange": {
    "id": "Ganti",
    "en": "Change",
    "ar": "تغيير",
    "fr": "Modifier",
    "de": "Ändern",
    "es": "Cambiar",
    "ru": "Изменить",
    "zh": "更换",
    "ja": "変更",
    "ko": "변경",
    "hi": "बदलें"
  },
  "proofRemove": {
    "id": "Hapus",
    "en": "Remove",
    "ar": "إزالة",
    "fr": "Supprimer",
    "de": "Entfernen",
    "es": "Eliminar",
    "ru": "Удалить",
    "zh": "删除",
    "ja": "削除",
    "ko": "삭제",
    "hi": "हटाएं"
  },
  "proofUploading": {
    "id": "Mengunggah…",
    "en": "Uploading…",
    "ar": "جارٍ الرفع…",
    "fr": "Téléversement en cours…",
    "de": "Wird hochgeladen…",
    "es": "Subiendo…",
    "ru": "Загрузка…",
    "zh": "上传中…",
    "ja": "アップロード中…",
    "ko": "업로드 중…",
    "hi": "अपलोड हो रहा है…"
  },
  "proofUploaded": {
    "id": "Bukti transfer terunggah.",
    "en": "Transfer proof uploaded successfully.",
    "ar": "تم رفع إثبات التحويل بنجاح.",
    "fr": "La preuve de virement a été téléversée avec succès.",
    "de": "Transfernachweis erfolgreich hochgeladen.",
    "es": "Comprobante de transferencia subido correctamente.",
    "ru": "Подтверждение перевода успешно загружено.",
    "zh": "转账凭证已成功上传。",
    "ja": "振込証明書が正常にアップロードされました。",
    "ko": "이체 증빙이 성공적으로 업로드되었습니다.",
    "hi": "ट्रांसफर प्रमाण सफलतापूर्वक अपलोड हो गया।"
  },
  "proofFailed": {
    "id": "Unggah bukti gagal. Coba lagi.",
    "en": "Failed to upload proof. Please try again.",
    "ar": "فشل رفع الإثبات. يرجى المحاولة مرة أخرى.",
    "fr": "Échec du téléversement de la preuve. Veuillez réessayer.",
    "de": "Hochladen des Nachweises fehlgeschlagen. Bitte versuche es erneut.",
    "es": "Error al subir el comprobante. Por favor, inténtalo de nuevo.",
    "ru": "Не удалось загрузить подтверждение. Пожалуйста, попробуйте снова.",
    "zh": "上传凭证失败，请重试。",
    "ja": "証明書のアップロードに失敗しました。もう一度お試しください。",
    "ko": "증빙 업로드에 실패했습니다. 다시 시도해 주세요.",
    "hi": "प्रमाण अपलोड करने में विफल। कृपया पुनः प्रयास करें।"
  },
  "proofTooLarge": {
    "id": "Ukuran berkas maksimal 8 MB.",
    "en": "Maximum file size is 8 MB.",
    "ar": "الحجم الأقصى للملف هو 8 ميغابايت.",
    "fr": "La taille maximale du fichier est de 8 Mo.",
    "de": "Die maximale Dateigröße beträgt 8 MB.",
    "es": "El tamaño máximo del archivo es de 8 MB.",
    "ru": "Максимальный размер файла составляет 8 МБ.",
    "zh": "文件最大不超过 8 MB。",
    "ja": "ファイルの最大サイズは 8 MB です。",
    "ko": "파일 최대 크기는 8 MB입니다.",
    "hi": "फ़ाइल का अधिकतम आकार 8 MB है।"
  },
  "proofInvalid": {
    "id": "Berkas harus berupa gambar (JPG, PNG, WebP).",
    "en": "File must be an image (JPG, PNG, WebP).",
    "ar": "يجب أن يكون الملف صورة (JPG أو PNG أو WebP).",
    "fr": "Le fichier doit être une image (JPG, PNG, WebP).",
    "de": "Die Datei muss ein Bild sein (JPG, PNG, WebP).",
    "es": "El archivo debe ser una imagen (JPG, PNG, WebP).",
    "ru": "Файл должен быть изображением (JPG, PNG, WebP).",
    "zh": "文件必须是图片格式（JPG、PNG、WebP）。",
    "ja": "ファイルは画像（JPG、PNG、WebP）である必要があります。",
    "ko": "파일은 이미지(JPG, PNG, WebP) 형식이어야 합니다.",
    "hi": "फ़ाइल एक छवि (JPG, PNG, WebP) होनी चाहिए।"
  },
  "proofView": {
    "id": "Lihat bukti",
    "en": "View Proof",
    "ar": "عرض الإثبات",
    "fr": "Voir la preuve",
    "de": "Nachweis anzeigen",
    "es": "Ver comprobante",
    "ru": "Просмотреть подтверждение",
    "zh": "查看凭证",
    "ja": "証明を見る",
    "ko": "증거 보기",
    "hi": "प्रमाण देखें"
  },
  "historyTitle": {
    "id": "Riwayat Donasi",
    "en": "Donation History",
    "ar": "سجل التبرعات",
    "fr": "Historique des dons",
    "de": "Spendenhistorie",
    "es": "Historial de donaciones",
    "ru": "История пожертвований",
    "zh": "捐款历史",
    "ja": "寄付履歴",
    "ko": "기부 내역",
    "hi": "दान इतिहास"
  },
  "historySubtitle": {
    "id": "Semua dukungan Anda — tanggal, nominal, metode, dan status.",
    "en": "All your support — date, amount, method, and status.",
    "ar": "جميع تبرعاتك — التاريخ، والمبلغ، والطريقة، والحالة.",
    "fr": "Tous vos soutiens — date, montant, méthode et statut.",
    "de": "Alle Ihre Unterstützungen — Datum, Betrag, Methode und Status.",
    "es": "Todo su apoyo — fecha, monto, método y estado.",
    "ru": "Все ваши пожертвования — дата, сумма, способ и статус.",
    "zh": "您所有的支持记录——日期、金额、方式和状态。",
    "ja": "すべてのご支援 — 日付、金額、方法、ステータス。",
    "ko": "모든 후원 내역 — 날짜, 금액, 방법 및 상태.",
    "hi": "आपका सारा समर्थन — तिथि, राशि, तरीका और स्थिति।"
  },
  "historyEmpty": {
    "id": "Belum ada donasi. Jazakumullah khairan atas niat baik Anda.",
    "en": "No donations yet. Jazakumullah khairan for your good intention.",
    "ar": "لا توجد تبرعات بعد. جزاكم الله خيراً على حسن نيتكم.",
    "fr": "Aucun don pour l'instant. Jazakumullah khairan pour votre bonne intention.",
    "de": "Noch keine Spenden. Jazakumullah khairan für Ihre gute Absicht.",
    "es": "Aún no hay donaciones. Jazakumullah khairan por su buena intención.",
    "ru": "Пожертвований пока нет. Jazakumullah khairan за ваше благое намерение.",
    "zh": "暂无捐款记录。Jazakumullah khairan，感谢您的善意。",
    "ja": "まだ寄付はありません。あなたの善意にJazakumullah khairan。",
    "ko": "아직 기부가 없습니다. 선한 의도에 Jazakumullah khairan.",
    "hi": "अभी तक कोई दान नहीं। आपकी नेक नीयत के लिए Jazakumullah khairan।"
  },
  "historyTotal": {
    "id": "Total terverifikasi",
    "en": "Total Verified",
    "ar": "الإجمالي الموثَّق",
    "fr": "Total vérifié",
    "de": "Verifizierter Gesamtbetrag",
    "es": "Total verificado",
    "ru": "Подтверждённый итог",
    "zh": "已核实总额",
    "ja": "確認済み合計",
    "ko": "확인된 총액",
    "hi": "सत्यापित कुल"
  },
  "historyCount": {
    "id": "{n} donasi berhasil",
    "en": "{n} donations successful",
    "ar": "{n} تبرعات ناجحة",
    "fr": "{n} dons réussis",
    "de": "{n} Spenden erfolgreich",
    "es": "{n} donaciones exitosas",
    "ru": "{n} пожертвований выполнено успешно",
    "zh": "{n} 笔捐款成功",
    "ja": "{n} 件の寄付が成功しました",
    "ko": "{n}건의 기부 성공",
    "hi": "{n} दान सफल"
  },
  "statusPaid": {
    "id": "Berhasil",
    "en": "Successful",
    "ar": "ناجح",
    "fr": "Réussi",
    "de": "Erfolgreich",
    "es": "Exitoso",
    "ru": "Успешно",
    "zh": "成功",
    "ja": "成功",
    "ko": "성공",
    "hi": "सफल"
  },
  "statusPending": {
    "id": "Menunggu pembayaran",
    "en": "Awaiting payment",
    "ar": "في انتظار الدفع",
    "fr": "En attente de paiement",
    "de": "Zahlung ausstehend",
    "es": "Esperando pago",
    "ru": "Ожидание оплаты",
    "zh": "等待付款",
    "ja": "お支払い待ち",
    "ko": "결제 대기 중",
    "hi": "भुगतान की प्रतीक्षा में"
  },
  "statusFailed": {
    "id": "Gagal / kedaluwarsa",
    "en": "Failed / expired",
    "ar": "فشل / منتهي الصلاحية",
    "fr": "Échoué / expiré",
    "de": "Fehlgeschlagen / abgelaufen",
    "es": "Fallido / vencido",
    "ru": "Не выполнено / истекло",
    "zh": "失败 / 已过期",
    "ja": "失敗 / 期限切れ",
    "ko": "실패 / 만료됨",
    "hi": "विफल / समाप्त"
  },
  "continuePay": {
    "id": "Lanjutkan pembayaran",
    "en": "Continue payment",
    "ar": "متابعة الدفع",
    "fr": "Continuer le paiement",
    "de": "Zahlung fortsetzen",
    "es": "Continuar pago",
    "ru": "Продолжить оплату",
    "zh": "继续付款",
    "ja": "支払いを続ける",
    "ko": "결제 계속하기",
    "hi": "भुगतान जारी रखें"
  },
  "viewAllHistory": {
    "id": "Lihat riwayat lengkap",
    "en": "View full history",
    "ar": "عرض السجل الكامل",
    "fr": "Voir l'historique complet",
    "de": "Vollständigen Verlauf anzeigen",
    "es": "Ver historial completo",
    "ru": "Просмотреть полную историю",
    "zh": "查看完整历史记录",
    "ja": "全履歴を見る",
    "ko": "전체 내역 보기",
    "hi": "पूरा इतिहास देखें"
  },
  "dataSaverTitle": {
    "id": "Mode Hemat Data",
    "en": "Data Saver Mode",
    "ar": "وضع توفير البيانات",
    "fr": "Mode Économie de Données",
    "de": "Datensparmodus",
    "es": "Modo Ahorro de Datos",
    "ru": "Режим экономии трафика",
    "zh": "流量节省模式",
    "ja": "データセーバーモード",
    "ko": "데이터 절약 모드",
    "hi": "डेटा सेवर मोड"
  },
  "dataSaverDesc": {
    "id": "Untuk koneksi roaming yang lambat: foto, peta, dan animasi dilewati agar halaman terbuka lebih cepat dan kuota lebih hemat. Doa, panduan, dan jadwal salat tetap lengkap.",
    "en": "For slow roaming connections: photos, maps, and animations are skipped so pages load faster and data usage is reduced. Du'a, guides, and prayer schedules remain fully available.",
    "ar": "لاتصالات التجوال البطيئة: يتم تخطي الصور والخرائط والرسوم المتحركة لتحميل الصفحات بشكل أسرع وتوفير البيانات. تبقى الأدعية والأدلة ومواقيت الصلاة متاحة بالكامل.",
    "fr": "Pour les connexions itinérantes lentes : les photos, cartes et animations sont ignorées pour que les pages se chargent plus vite et que les données soient économisées. Les invocations, guides et horaires de prière restent entièrement disponibles.",
    "de": "Für langsame Roaming-Verbindungen: Fotos, Karten und Animationen werden übersprungen, damit Seiten schneller laden und das Datenvolumen geschont wird. Du'a, Anleitungen und Gebetszeiten bleiben vollständig verfügbar.",
    "es": "Para conexiones de itinerancia lentas: las fotos, mapas y animaciones se omiten para que las páginas carguen más rápido y se reduzca el uso de datos. Las du'a, guías y horarios de oración permanecen completamente disponibles.",
    "ru": "Для медленных роуминговых соединений: фотографии, карты и анимации пропускаются, чтобы страницы загружались быстрее и расходовалось меньше трафика. Ду'а, руководства и расписание намазов остаются полностью доступными.",
    "zh": "针对漫游慢速连接：跳过照片、地图和动画，以便页面加载更快、流量更省。杜阿、指南和礼拜时间表仍完整提供。",
    "ja": "低速ローミング接続向け：ページの読み込みを速くしデータ通信量を節約するために、写真・地図・アニメーションをスキップします。ドゥアー、ガイド、礼拝スケジュールは引き続き完全にご利用いただけます。",
    "ko": "느린 로밍 연결을 위한 설정: 페이지를 더 빠르게 로드하고 데이터를 절약하기 위해 사진, 지도, 애니메이션을 건너뜁니다. 두아, 가이드, 예배 일정은 완전히 제공됩니다.",
    "hi": "धीमे रोमिंग कनेक्शन के लिए: पृष्ठ तेज़ी से खुलें और कोटा बचाने के लिए फ़ोटो, मानचित्र और एनिमेशन छोड़ दिए जाते हैं। दुआ, गाइड और नमाज़ के समय-सारणी पूरी तरह उपलब्ध रहते हैं।"
  },
  "dataSaverSkipPhotos": {
    "id": "Foto & ilustrasi tidak diunduh otomatis — ketuk untuk memuat",
    "en": "Photos & illustrations are not downloaded automatically — tap to load",
    "ar": "الصور والرسوم التوضيحية لا تُحمَّل تلقائياً — اضغط للتحميل",
    "fr": "Les photos et illustrations ne sont pas téléchargées automatiquement — appuyez pour charger",
    "de": "Fotos & Illustrationen werden nicht automatisch geladen — zum Laden antippen",
    "es": "Las fotos e ilustraciones no se descargan automáticamente — toca para cargar",
    "ru": "Фотографии и иллюстрации не загружаются автоматически — нажмите для загрузки",
    "zh": "照片和插图不会自动下载——点击以加载",
    "ja": "写真・イラストは自動ダウンロードされません — タップして読み込む",
    "ko": "사진 및 일러스트는 자동으로 다운로드되지 않습니다 — 탭하여 불러오기",
    "hi": "फ़ोटो और चित्र स्वचालित रूप से डाउनलोड नहीं होते — लोड करने के लिए टैप करें"
  },
  "dataSaverSkipMaps": {
    "id": "Peta interaktif dimuat hanya saat Anda minta",
    "en": "Interactive maps are loaded only when you request them",
    "ar": "تُحمَّل الخرائط التفاعلية فقط عند طلبك",
    "fr": "Les cartes interactives sont chargées uniquement à votre demande",
    "de": "Interaktive Karten werden nur auf Anfrage geladen",
    "es": "Los mapas interactivos se cargan solo cuando los solicitas",
    "ru": "Интерактивные карты загружаются только по вашему запросу",
    "zh": "互动地图仅在您请求时加载",
    "ja": "インタラクティブマップはリクエスト時のみ読み込まれます",
    "ko": "인터랙티브 지도는 요청 시에만 로드됩니다",
    "hi": "इंटरैक्टिव मानचित्र केवल तब लोड होते हैं जब आप अनुरोध करते हैं"
  },
  "dataSaverSkipMotion": {
    "id": "Animasi & transisi dimatikan",
    "en": "Animations & transitions are disabled",
    "ar": "الرسوم المتحركة والانتقالات معطَّلة",
    "fr": "Les animations et transitions sont désactivées",
    "de": "Animationen & Übergänge sind deaktiviert",
    "es": "Las animaciones y transiciones están desactivadas",
    "ru": "Анимации и переходы отключены",
    "zh": "动画和过渡效果已关闭",
    "ja": "アニメーションとトランジションは無効になっています",
    "ko": "애니메이션 및 전환 효과가 비활성화되었습니다",
    "hi": "एनिमेशन और ट्रांज़िशन अक्षम हैं"
  },
  "dataSaverSlowDetected": {
    "id": "Koneksi lambat / hemat data terdeteksi",
    "en": "Slow connection / data saver detected",
    "ar": "تم اكتشاف اتصال بطيء / وضع توفير البيانات",
    "fr": "Connexion lente / économie de données détectée",
    "de": "Langsame Verbindung / Datensparmodus erkannt",
    "es": "Conexión lenta / ahorro de datos detectado",
    "ru": "Обнаружено медленное соединение / режим экономии трафика",
    "zh": "检测到慢速连接 / 流量节省模式",
    "ja": "低速接続 / データセーバーが検出されました",
    "ko": "느린 연결 / 데이터 절약 모드가 감지되었습니다",
    "hi": "धीमा कनेक्शन / डेटा सेवर मोड का पता चला"
  },
  "dataSaverNetworkOk": {
    "id": "Koneksi normal",
    "en": "Normal connection",
    "ar": "اتصال عادي",
    "fr": "Connexion normale",
    "de": "Normale Verbindung",
    "es": "Conexión normal",
    "ru": "Обычное соединение",
    "zh": "正常连接",
    "ja": "通常接続",
    "ko": "일반 연결",
    "hi": "सामान्य कनेक्शन"
  },
  "dataSaverAuto": {
    "id": "Mengikuti pengaturan hemat data browser secara otomatis",
    "en": "Automatically follows browser data saver settings",
    "ar": "يتبع إعدادات توفير البيانات في المتصفح تلقائيًا",
    "fr": "Suit automatiquement les paramètres d'économie de données du navigateur",
    "de": "Folgt automatisch den Datenspar-Einstellungen des Browsers",
    "es": "Sigue automáticamente la configuración de ahorro de datos del navegador",
    "ru": "Автоматически следует настройкам экономии данных браузера",
    "zh": "自动跟随浏览器节省数据设置",
    "ja": "ブラウザのデータ節約設定に自動的に従う",
    "ko": "브라우저 데이터 절약 설정을 자동으로 따름",
    "hi": "ब्राउज़र की डेटा सेवर सेटिंग का स्वचालित रूप से अनुसरण करता है"
  },
  "dataSaverFollowAuto": {
    "id": "Kembali ke otomatis",
    "en": "Back to automatic",
    "ar": "العودة إلى التلقائي",
    "fr": "Retour en automatique",
    "de": "Zurück zu automatisch",
    "es": "Volver a automático",
    "ru": "Вернуться к автоматическому режиму",
    "zh": "返回自动模式",
    "ja": "自動に戻す",
    "ko": "자동으로 돌아가기",
    "hi": "स्वचालित पर वापस जाएं"
  },
  "dataSaverSuggest": {
    "id": "Koneksi lambat terdeteksi — Mode Hemat Data aktif otomatis agar halaman terbuka lebih cepat. Foto & peta dimuat saat diketuk.",
    "en": "Slow connection detected — Data Saver Mode activated automatically so pages load faster. Photos & maps load when tapped.",
    "ar": "تم اكتشاف اتصال بطيء — تم تفعيل وضع توفير البيانات تلقائيًا لتحميل الصفحات بشكل أسرع. الصور والخرائط تُحمَّل عند النقر عليها.",
    "fr": "Connexion lente détectée — Le mode Économiseur de données est activé automatiquement pour que les pages se chargent plus vite. Les photos et cartes se chargent au toucher.",
    "de": "Langsame Verbindung erkannt — Datensparmodus wurde automatisch aktiviert, damit Seiten schneller laden. Fotos & Karten werden beim Antippen geladen.",
    "es": "Conexión lenta detectada — El modo Ahorro de datos se activó automáticamente para que las páginas carguen más rápido. Las fotos y mapas se cargan al tocar.",
    "ru": "Обнаружено медленное соединение — режим экономии данных включён автоматически для ускорения загрузки страниц. Фото и карты загружаются при нажатии.",
    "zh": "检测到网络缓慢——省流量模式已自动启用，以加快页面加载速度。照片和地图点击后才会加载。",
    "ja": "低速接続が検出されました — ページをより速く読み込むためにデータセーバーモードが自動的に有効になりました。写真と地図はタップ時に読み込まれます。",
    "ko": "느린 연결이 감지되었습니다 — 페이지를 더 빨리 불러오기 위해 데이터 절약 모드가 자동으로 활성화되었습니다. 사진과 지도는 탭할 때 불러옵니다.",
    "hi": "धीमा कनेक्शन पाया गया — पेज जल्दी खुलें इसलिए डेटा सेवर मोड स्वतः चालू हो गया। फ़ोटो और मानचित्र टैप करने पर लोड होते हैं।"
  },
  "dataSaverDisable": {
    "id": "Matikan",
    "en": "Turn Off",
    "ar": "إيقاف التشغيل",
    "fr": "Désactiver",
    "de": "Deaktivieren",
    "es": "Desactivar",
    "ru": "Отключить",
    "zh": "关闭",
    "ja": "オフにする",
    "ko": "끄기",
    "hi": "बंद करें"
  },
  "dataSaverOk": {
    "id": "Oke",
    "en": "OK",
    "ar": "حسنًا",
    "fr": "OK",
    "de": "OK",
    "es": "Aceptar",
    "ru": "ОК",
    "zh": "好的",
    "ja": "OK",
    "ko": "확인",
    "hi": "ठीक है"
  },
  "dataSaverEnable": {
    "id": "Aktifkan",
    "en": "Enable",
    "ar": "تفعيل",
    "fr": "Activer",
    "de": "Aktivieren",
    "es": "Activar",
    "ru": "Включить",
    "zh": "启用",
    "ja": "有効にする",
    "ko": "활성화",
    "hi": "सक्षम करें"
  },
  "dataSaverLater": {
    "id": "Nanti",
    "en": "Later",
    "ar": "لاحقًا",
    "fr": "Plus tard",
    "de": "Später",
    "es": "Más tarde",
    "ru": "Позже",
    "zh": "稍后",
    "ja": "後で",
    "ko": "나중에",
    "hi": "बाद में"
  },
  "dataSaverPhotoHidden": {
    "id": "Foto disembunyikan (Mode Hemat Data)",
    "en": "Photo hidden (Data Saver Mode)",
    "ar": "الصورة مخفية (وضع توفير البيانات)",
    "fr": "Photo masquée (Mode Économie de données)",
    "de": "Foto ausgeblendet (Datensparmodus)",
    "es": "Foto oculta (Modo ahorro de datos)",
    "ru": "Фото скрыто (Режим экономии данных)",
    "zh": "照片已隐藏（省流量模式）",
    "ja": "写真は非表示です（データセーバーモード）",
    "ko": "사진 숨김 (데이터 절약 모드)",
    "hi": "फ़ोटो छुपाई गई (डेटा सेवर मोड)"
  },
  "dataSaverTapToLoad": {
    "id": "Ketuk untuk memuat",
    "en": "Tap to load",
    "ar": "اضغط للتحميل",
    "fr": "Appuyez pour charger",
    "de": "Zum Laden tippen",
    "es": "Toca para cargar",
    "ru": "Нажмите для загрузки",
    "zh": "点击加载",
    "ja": "タップして読み込む",
    "ko": "탭하여 로드",
    "hi": "लोड करने के लिए टैप करें"
  },
  "dataSaverShowMap": {
    "id": "Tampilkan peta",
    "en": "Show map",
    "ar": "عرض الخريطة",
    "fr": "Afficher la carte",
    "de": "Karte anzeigen",
    "es": "Mostrar mapa",
    "ru": "Показать карту",
    "zh": "显示地图",
    "ja": "地図を表示する",
    "ko": "지도 표시",
    "hi": "मानचित्र दिखाएं"
  },
  "dataSaverMapHidden": {
    "id": "Peta tidak dimuat otomatis dalam Mode Hemat Data.",
    "en": "Map is not loaded automatically in Data Saver Mode.",
    "ar": "لا يتم تحميل الخريطة تلقائيًا في وضع توفير البيانات.",
    "fr": "La carte ne se charge pas automatiquement en Mode Économie de données.",
    "de": "Die Karte wird im Datensparmodus nicht automatisch geladen.",
    "es": "El mapa no se carga automáticamente en el Modo ahorro de datos.",
    "ru": "Карта не загружается автоматически в режиме экономии данных.",
    "zh": "在省流量模式下，地图不会自动加载。",
    "ja": "データセーバーモードでは、地図は自動的に読み込まれません。",
    "ko": "데이터 절약 모드에서는 지도가 자동으로 로드되지 않습니다.",
    "hi": "डेटा सेवर मोड में मानचित्र स्वचालित रूप से लोड नहीं होता।"
  },
  "paypalTitle": {
    "id": "Dukung lewat PayPal",
    "en": "Support via PayPal",
    "ar": "ادعم عبر PayPal",
    "fr": "Soutenir via PayPal",
    "de": "Unterstützen via PayPal",
    "es": "Apoyar a través de PayPal",
    "ru": "Поддержать через PayPal",
    "zh": "通过 PayPal 支持",
    "ja": "PayPal で支援する",
    "ko": "PayPal로 후원하기",
    "hi": "PayPal के माध्यम से सहयोग करें"
  },
  "paypalSubtitle": {
    "id": "Untuk jamaah di luar Indonesia. Pilih mata uang dan nominal, lalu bayar dengan akun PayPal atau kartu.",
    "en": "For pilgrims outside Indonesia. Select your currency and amount, then pay with your PayPal account or card.",
    "ar": "للحجاج خارج إندونيسيا. اختر العملة والمبلغ، ثم ادفع باستخدام حساب PayPal أو البطاقة.",
    "fr": "Pour les pèlerins en dehors de l'Indonésie. Sélectionnez la devise et le montant, puis payez avec votre compte PayPal ou une carte.",
    "de": "Für Pilger außerhalb Indonesiens. Wählen Sie Währung und Betrag, und bezahlen Sie dann mit Ihrem PayPal-Konto oder einer Karte.",
    "es": "Para peregrinos fuera de Indonesia. Selecciona la moneda y el monto, luego paga con tu cuenta de PayPal o tarjeta.",
    "ru": "Для паломников за пределами Индонезии. Выберите валюту и сумму, затем оплатите с помощью аккаунта PayPal или карты.",
    "zh": "适用于印度尼西亚以外的朝觉者。选择货币和金额，然后使用 PayPal 账户或银行卡付款。",
    "ja": "インドネシア国外の巡礼者向けです。通貨と金額を選択し、PayPal アカウントまたはカードでお支払いください。",
    "ko": "인도네시아 외 지역의 순례자를 위한 옵션입니다. 통화와 금액을 선택한 후 PayPal 계정 또는 카드로 결제하세요.",
    "hi": "इंडोनेशिया के बाहर के हाजियों के लिए। मुद्रा और राशि चुनें, फिर अपने PayPal खाते या कार्ड से भुगतान करें।"
  },
  "currencyLabel": {
    "id": "Mata uang",
    "en": "Currency",
    "ar": "العملة",
    "fr": "Devise",
    "de": "Währung",
    "es": "Moneda",
    "ru": "Валюта",
    "zh": "货币",
    "ja": "通貨",
    "ko": "통화",
    "hi": "मुद्रा"
  },
  "paypalSandbox": {
    "id": "Mode sandbox PayPal — tidak ada tagihan nyata.",
    "en": "PayPal sandbox mode — no real charges.",
    "ar": "وضع PayPal التجريبي — لا توجد رسوم حقيقية.",
    "fr": "Mode sandbox PayPal — aucun frais réel.",
    "de": "PayPal-Sandbox-Modus — keine echten Gebühren.",
    "es": "Modo sandbox de PayPal — sin cargos reales.",
    "ru": "Режим песочницы PayPal — реальных списаний нет.",
    "zh": "PayPal 沙盒模式 — 不会产生真实费用。",
    "ja": "PayPal サンドボックスモード — 実際の請求はありません。",
    "ko": "PayPal 샌드박스 모드 — 실제 청구 없음.",
    "hi": "PayPal सैंडबॉक्स मोड — कोई वास्तविक शुल्क नहीं।"
  },
  "paypalLoading": {
    "id": "Memuat PayPal…",
    "en": "Loading PayPal…",
    "ar": "جارٍ تحميل PayPal…",
    "fr": "Chargement de PayPal…",
    "de": "PayPal wird geladen…",
    "es": "Cargando PayPal…",
    "ru": "Загрузка PayPal…",
    "zh": "正在加载 PayPal…",
    "ja": "PayPal を読み込み中…",
    "ko": "PayPal 불러오는 중…",
    "hi": "PayPal लोड हो रहा है…"
  },
  "paypalLoadFailed": {
    "id": "PayPal tidak dapat dimuat. Periksa koneksi atau pemblokir iklan, lalu muat ulang halaman.",
    "en": "PayPal could not be loaded. Check your connection or ad blocker, then reload the page.",
    "ar": "تعذّر تحميل PayPal. تحقق من اتصالك أو مانع الإعلانات، ثم أعد تحميل الصفحة.",
    "fr": "PayPal n'a pas pu être chargé. Vérifiez votre connexion ou votre bloqueur de publicités, puis rechargez la page.",
    "de": "PayPal konnte nicht geladen werden. Überprüfen Sie Ihre Verbindung oder Ihren Werbeblocker und laden Sie die Seite neu.",
    "es": "No se pudo cargar PayPal. Comprueba tu conexión o bloqueador de anuncios y vuelve a cargar la página.",
    "ru": "Не удалось загрузить PayPal. Проверьте подключение или блокировщик рекламы, затем перезагрузите страницу.",
    "zh": "PayPal 无法加载。请检查您的网络连接或广告拦截器，然后重新加载页面。",
    "ja": "PayPal を読み込めませんでした。接続または広告ブロッカーを確認して、ページを再読み込みしてください。",
    "ko": "PayPal을 불러올 수 없습니다. 연결 상태 또는 광고 차단기를 확인한 후 페이지를 새로 고치세요.",
    "hi": "PayPal लोड नहीं हो सका। अपना कनेक्शन या विज्ञापन अवरोधक जाँचें, फिर पेज पुनः लोड करें।"
  },
  "paypalCancelled": {
    "id": "Pembayaran PayPal dibatalkan.",
    "en": "PayPal payment cancelled.",
    "ar": "تم إلغاء الدفع عبر PayPal.",
    "fr": "Paiement PayPal annulé.",
    "de": "PayPal-Zahlung abgebrochen.",
    "es": "Pago de PayPal cancelado.",
    "ru": "Платёж через PayPal отменён.",
    "zh": "PayPal 付款已取消。",
    "ja": "PayPal の支払いがキャンセルされました。",
    "ko": "PayPal 결제가 취소되었습니다.",
    "hi": "PayPal भुगतान रद्द कर दिया गया।"
  },
  "paypalNote": {
    "id": "Pembayaran aman diproses oleh PayPal. Bukti pembayaran dikirim oleh PayPal ke e-mail Anda.",
    "en": "Payment is securely processed by PayPal. A payment receipt will be sent by PayPal to your email.",
    "ar": "تتم معالجة الدفع بأمان عبر PayPal. سيُرسل PayPal إيصال الدفع إلى بريدك الإلكتروني.",
    "fr": "Le paiement est traité en toute sécurité par PayPal. Un reçu de paiement vous sera envoyé par PayPal à votre adresse e-mail.",
    "de": "Die Zahlung wird sicher über PayPal abgewickelt. Eine Zahlungsbestätigung wird von PayPal an Ihre E-Mail-Adresse gesendet.",
    "es": "El pago es procesado de forma segura por PayPal. PayPal enviará un comprobante de pago a su correo electrónico.",
    "ru": "Платёж безопасно обрабатывается через PayPal. Квитанция об оплате будет отправлена PayPal на вашу электронную почту.",
    "zh": "付款由 PayPal 安全处理。PayPal 将向您的电子邮件发送付款收据。",
    "ja": "お支払いは PayPal によって安全に処理されます。支払い領収書は PayPal からお客様のメールアドレスに送信されます。",
    "ko": "결제는 PayPal을 통해 안전하게 처리됩니다. PayPal이 결제 영수증을 귀하의 이메일로 발송합니다.",
    "hi": "भुगतान PayPal द्वारा सुरक्षित रूप से संसाधित किया जाता है। PayPal द्वारा भुगतान की रसीद आपके ईमेल पर भेजी जाएगी।"
  },
  "manualConfirmTitle": {
    "id": "Saya sudah transfer — kirim konfirmasi",
    "en": "I have transferred — send confirmation",
    "ar": "لقد أجريت التحويل — أرسِل التأكيد",
    "fr": "J'ai effectué le virement — envoyer la confirmation",
    "de": "Ich habe überwiesen — Bestätigung senden",
    "es": "Ya realicé la transferencia — enviar confirmación",
    "ru": "Я перевёл средства — отправить подтверждение",
    "zh": "我已完成转账——发送确认",
    "ja": "送金済み — 確認を送信する",
    "ko": "이체 완료 — 확인 전송",
    "hi": "मैंने ट्रांसफर कर दिया है — पुष्टि भेजें"
  },
  "methodPaypalme": {
    "id": "PayPal",
    "en": "PayPal",
    "ar": "PayPal",
    "fr": "PayPal",
    "de": "PayPal",
    "es": "PayPal",
    "ru": "PayPal",
    "zh": "PayPal",
    "ja": "PayPal",
    "ko": "PayPal",
    "hi": "PayPal"
  },
  "methodPaypalmeHint": {
    "id": "Kirim ke PayPal.Me / QR PayPal",
    "en": "Send via PayPal.Me / PayPal QR",
    "ar": "أرسل عبر PayPal.Me / رمز QR الخاص بـ PayPal",
    "fr": "Envoyer via PayPal.Me / QR PayPal",
    "de": "Senden über PayPal.Me / PayPal-QR",
    "es": "Enviar mediante PayPal.Me / QR de PayPal",
    "ru": "Отправить через PayPal.Me / QR-код PayPal",
    "zh": "通过 PayPal.Me / PayPal 二维码发送",
    "ja": "PayPal.Me / PayPal QR コードで送金",
    "ko": "PayPal.Me / PayPal QR로 보내기",
    "hi": "PayPal.Me / PayPal QR के माध्यम से भेजें"
  },
  "paypalmeTitle": {
    "id": "Dukung lewat PayPal",
    "en": "Support via PayPal",
    "ar": "ادعم عبر PayPal",
    "fr": "Soutenir via PayPal",
    "de": "Unterstützen über PayPal",
    "es": "Apoyar mediante PayPal",
    "ru": "Поддержать через PayPal",
    "zh": "通过 PayPal 支持",
    "ja": "PayPal でサポートする",
    "ko": "PayPal로 후원하기",
    "hi": "PayPal के माध्यम से समर्थन करें"
  },
  "paypalmeSubtitle": {
    "id": "Untuk jamaah di luar Indonesia. Buka tautan PayPal atau pindai kode QR dengan aplikasi PayPal, kirim dukungan Anda, lalu isi konfirmasi di bawah agar lencana Pendukung diaktifkan setelah diverifikasi.",
    "en": "For pilgrims outside Indonesia. Open the PayPal link or scan the QR code with the PayPal app, send your support, then fill in the confirmation below so that the Supporter badge is activated after verification.",
    "ar": "للحجاج خارج إندونيسيا. افتح رابط PayPal أو امسح رمز QR ضوئيًا باستخدام تطبيق PayPal، وأرسل دعمك، ثم املأ نموذج التأكيد أدناه حتى يتم تفعيل شارة المؤيد بعد التحقق.",
    "fr": "Pour les pèlerins en dehors de l'Indonésie. Ouvrez le lien PayPal ou scannez le code QR avec l'application PayPal, envoyez votre soutien, puis remplissez la confirmation ci-dessous afin que le badge Supporteur soit activé après vérification.",
    "de": "Für Pilger außerhalb Indonesiens. Öffnen Sie den PayPal-Link oder scannen Sie den QR-Code mit der PayPal-App, senden Sie Ihre Unterstützung, und füllen Sie dann die Bestätigung unten aus, damit das Unterstützer-Abzeichen nach der Überprüfung aktiviert wird.",
    "es": "Para peregrinos fuera de Indonesia. Abre el enlace de PayPal o escanea el código QR con la aplicación de PayPal, envía tu apoyo y luego completa la confirmación a continuación para que la insignia de Colaborador se active tras la verificación.",
    "ru": "Для паломников за пределами Индонезии. Откройте ссылку PayPal или отсканируйте QR-код с помощью приложения PayPal, отправьте свою поддержку, затем заполните подтверждение ниже, чтобы значок Сторонника был активирован после проверки.",
    "zh": "面向印度尼西亚以外的朝圣者。请打开PayPal链接或使用PayPal应用扫描二维码，发送您的支持，然后填写下方确认表，以便在验证后激活支持者徽章。",
    "ja": "インドネシア国外の巡礼者の方へ。PayPalリンクを開くか、PayPalアプリでQRコードをスキャンし、サポートを送信してから、確認後にサポーターバッジが有効になるよう、以下の確認フォームにご記入ください。",
    "ko": "인도네시아 외 지역의 순례자를 위한 안내입니다. PayPal 링크를 열거나 PayPal 앱으로 QR 코드를 스캔하여 후원을 보내신 후, 확인 절차를 거쳐 서포터 배지가 활성화될 수 있도록 아래 확인란을 작성해 주세요.",
    "hi": "इंडोनेशिया के बाहर के तीर्थयात्रियों के लिए। PayPal लिंक खोलें या PayPal ऐप से QR कोड स्कैन करें, अपना समर्थन भेजें, फिर नीचे दी गई पुष्टि भरें ताकि सत्यापन के बाद सपोर्टर बैज सक्रिय हो सके।"
  },
  "paypalmeOpen": {
    "id": "Buka PayPal",
    "en": "Open PayPal",
    "ar": "فتح PayPal",
    "fr": "Ouvrir PayPal",
    "de": "PayPal öffnen",
    "es": "Abrir PayPal",
    "ru": "Открыть PayPal",
    "zh": "打开PayPal",
    "ja": "PayPalを開く",
    "ko": "PayPal 열기",
    "hi": "PayPal खोलें"
  },
  "paypalmeCopy": {
    "id": "Salin tautan",
    "en": "Copy link",
    "ar": "نسخ الرابط",
    "fr": "Copier le lien",
    "de": "Link kopieren",
    "es": "Copiar enlace",
    "ru": "Скопировать ссылку",
    "zh": "复制链接",
    "ja": "リンクをコピー",
    "ko": "링크 복사",
    "hi": "लिंक कॉपी करें"
  },
  "paypalmeCopied": {
    "id": "Tautan PayPal disalin.",
    "en": "PayPal link copied.",
    "ar": "تم نسخ رابط PayPal.",
    "fr": "Lien PayPal copié.",
    "de": "PayPal-Link kopiert.",
    "es": "Enlace de PayPal copiado.",
    "ru": "Ссылка PayPal скопирована.",
    "zh": "PayPal链接已复制。",
    "ja": "PayPalリンクをコピーしました。",
    "ko": "PayPal 링크가 복사되었습니다.",
    "hi": "PayPal लिंक कॉपी किया गया।"
  },
  "paypalmeScan": {
    "id": "Pindai kode QR ini dengan aplikasi PayPal di ponsel Anda",
    "en": "Scan this QR code with the PayPal app on your phone",
    "ar": "امسح رمز QR هذا ضوئيًا باستخدام تطبيق PayPal على هاتفك",
    "fr": "Scannez ce code QR avec l'application PayPal sur votre téléphone",
    "de": "Scannen Sie diesen QR-Code mit der PayPal-App auf Ihrem Telefon",
    "es": "Escanea este código QR con la aplicación PayPal en tu teléfono",
    "ru": "Отсканируйте этот QR-код с помощью приложения PayPal на вашем телефоне",
    "zh": "使用手机上的PayPal应用扫描此二维码",
    "ja": "スマートフォンのPayPalアプリでこのQRコードをスキャンしてください",
    "ko": "휴대폰의 PayPal 앱으로 이 QR 코드를 스캔하세요",
    "hi": "अपने फ़ोन पर PayPal ऐप से इस QR कोड को स्कैन करें"
  },
  "paypalmeRecipient": {
    "id": "Penerima: {name}",
    "en": "Recipient: {name}",
    "ar": "المستلم: {name}",
    "fr": "Destinataire : {name}",
    "de": "Empfänger: {name}",
    "es": "Destinatario: {name}",
    "ru": "Получатель: {name}",
    "zh": "收款人：{name}",
    "ja": "受取人：{name}",
    "ko": "수신자: {name}",
    "hi": "प्राप्तकर्ता: {name}"
  },
  "paypalmeStep1": {
    "id": "Buka tautan PayPal (atau pindai QR) dan pastikan nama penerima sesuai.",
    "en": "Open the PayPal link (or scan the QR code) and make sure the recipient's name is correct.",
    "ar": "افتح رابط PayPal (أو امسح رمز QR) وتأكد من أن اسم المستلم صحيح.",
    "fr": "Ouvrez le lien PayPal (ou scannez le QR code) et assurez-vous que le nom du destinataire est correct.",
    "de": "Öffnen Sie den PayPal-Link (oder scannen Sie den QR-Code) und stellen Sie sicher, dass der Name des Empfängers korrekt ist.",
    "es": "Abre el enlace de PayPal (o escanea el código QR) y asegúrate de que el nombre del destinatario sea correcto.",
    "ru": "Откройте ссылку PayPal (или отсканируйте QR-код) и убедитесь, что имя получателя указано верно.",
    "zh": "打开PayPal链接（或扫描二维码），确认收款人姓名正确无误。",
    "ja": "PayPalのリンクを開く（またはQRコードをスキャンする）、受取人の名前が正しいことを確認してください。",
    "ko": "PayPal 링크를 열거나 QR 코드를 스캔하고 수신자 이름이 올바른지 확인하세요.",
    "hi": "PayPal लिंक खोलें (या QR कोड स्कैन करें) और सुनिश्चित करें कि प्राप्तकर्ता का नाम सही है।"
  },
  "paypalmeStep2": {
    "id": "Masukkan nominal dalam mata uang Anda, lalu selesaikan pembayaran dengan saldo PayPal atau kartu.",
    "en": "Enter the amount in your currency, then complete the payment using your PayPal balance or card.",
    "ar": "أدخل المبلغ بعملتك، ثم أتمّ الدفع باستخدام رصيد PayPal أو البطاقة.",
    "fr": "Entrez le montant dans votre devise, puis finalisez le paiement avec votre solde PayPal ou votre carte.",
    "de": "Geben Sie den Betrag in Ihrer Währung ein und schließen Sie die Zahlung mit Ihrem PayPal-Guthaben oder Ihrer Karte ab.",
    "es": "Ingresa el monto en tu moneda y luego completa el pago con tu saldo de PayPal o tarjeta.",
    "ru": "Введите сумму в вашей валюте, затем завершите оплату с помощью баланса PayPal или карты.",
    "zh": "以您的货币输入金额，然后使用PayPal余额或银行卡完成付款。",
    "ja": "ご自身の通貨で金額を入力し、PayPal残高またはカードで支払いを完了してください。",
    "ko": "귀하의 통화로 금액을 입력한 후 PayPal 잔액 또는 카드로 결제를 완료하세요.",
    "hi": "अपनी मुद्रा में राशि दर्ज करें, फिर PayPal बैलेंस या कार्ड से भुगतान पूरा करें।"
  },
  "paypalmeStep3": {
    "id": "Kembali ke sini dan kirim konfirmasi (nominal, mata uang, tanggal, ID transaksi). Admin memverifikasi dalam 1–3 hari kerja.",
    "en": "Come back here and send a confirmation (amount, currency, date, transaction ID). Admin will verify within 1–3 business days.",
    "ar": "عُد إلى هنا وأرسل التأكيد (المبلغ، العملة، التاريخ، معرّف المعاملة). سيقوم المشرف بالتحقق خلال 1–3 أيام عمل.",
    "fr": "Revenez ici et envoyez une confirmation (montant, devise, date, ID de transaction). L'administrateur vérifiera dans un délai de 1 à 3 jours ouvrables.",
    "de": "Kommen Sie hierher zurück und senden Sie eine Bestätigung (Betrag, Währung, Datum, Transaktions-ID). Der Administrator überprüft dies innerhalb von 1–3 Werktagen.",
    "es": "Regresa aquí y envía una confirmación (monto, moneda, fecha, ID de transacción). El administrador verificará en 1–3 días hábiles.",
    "ru": "Вернитесь сюда и отправьте подтверждение (сумма, валюта, дата, ID транзакции). Администратор проверит в течение 1–3 рабочих дней.",
    "zh": "返回此处并发送确认信息（金额、货币、日期、交易ID）。管理员将在1–3个工作日内完成核实。",
    "ja": "こちらに戻り、確認情報（金額、通貨、日付、取引ID）を送信してください。管理者が1〜3営業日以内に確認します。",
    "ko": "여기로 돌아와 확인 정보(금액, 통화, 날짜, 거래 ID)를 보내주세요. 관리자가 1–3 영업일 이내에 확인합니다.",
    "hi": "यहाँ वापस आएं और पुष्टि भेजें (राशि, मुद्रा, तारीख, लेनदेन ID)। व्यवस्थापक 1–3 कार्य दिवसों में सत्यापन करेगा।"
  },
  "paypalmeNote": {
    "id": "PayPal tidak mendukung Rupiah (IDR) — pilih USD, EUR, atau mata uang lain yang tersedia. Pilih \"Kirim ke teman\" bila tersedia agar bebas biaya.",
    "en": "PayPal does not support Rupiah (IDR) — choose USD, EUR, or another available currency. Select \"Send to a friend\" if available to avoid fees.",
    "ar": "لا يدعم PayPal الروبية الإندونيسية (IDR) — اختر USD أو EUR أو أي عملة أخرى متاحة. اختر \"إرسال إلى صديق\" إن توفّر ذلك لتجنّب الرسوم.",
    "fr": "PayPal ne prend pas en charge la Roupie (IDR) — choisissez USD, EUR ou une autre devise disponible. Sélectionnez \"Envoyer à un ami\" si disponible pour éviter les frais.",
    "de": "PayPal unterstützt keine Rupiah (IDR) — wählen Sie USD, EUR oder eine andere verfügbare Währung. Wählen Sie „An einen Freund senden\", falls verfügbar, um Gebühren zu vermeiden.",
    "es": "PayPal no admite la Rupia (IDR) — elige USD, EUR u otra moneda disponible. Selecciona \"Enviar a un amigo\" si está disponible para evitar comisiones.",
    "ru": "PayPal не поддерживает рупию (IDR) — выберите USD, EUR или другую доступную валюту. Выберите «Отправить другу», если доступно, чтобы избежать комиссий.",
    "zh": "PayPal不支持印尼盾（IDR）——请选择美元、欧元或其他可用货币。如有\"发送给朋友\"选项，请选择该选项以免除手续费。",
    "ja": "PayPalはルピア（IDR）に対応していません。USD、EUR、またはその他の利用可能な通貨を選択してください。手数料を避けるため、「友人に送る」が選択可能であればそちらを選んでください。",
    "ko": "PayPal은 루피아(IDR)를 지원하지 않습니다 — USD, EUR 또는 사용 가능한 다른 통화를 선택하세요. 수수료를 피하려면 \"친구에게 보내기\"를 선택하세요(가능한 경우).",
    "hi": "PayPal रुपिया (IDR) का समर्थन नहीं करता — USD, EUR, या अन्य उपलब्ध मुद्रा चुनें। शुल्क से बचने के लिए \"मित्र को भेजें\" चुनें यदि उपलब्ध हो।"
  },
  "paypalmeRefPlaceholder": {
    "id": "mis. ID transaksi PayPal (17 karakter) atau e-mail pengirim",
    "en": "e.g. PayPal transaction ID (17 characters) or sender's email",
    "ar": "مثال: معرّف معاملة PayPal (17 حرفاً) أو البريد الإلكتروني للمُرسِل",
    "fr": "ex. ID de transaction PayPal (17 caractères) ou e-mail de l'expéditeur",
    "de": "z. B. PayPal-Transaktions-ID (17 Zeichen) oder E-Mail des Absenders",
    "es": "ej. ID de transacción de PayPal (17 caracteres) o correo del remitente",
    "ru": "напр. ID транзакции PayPal (17 символов) или e-mail отправителя",
    "zh": "例如：PayPal交易ID（17位字符）或发件人电子邮件",
    "ja": "例：PayPal取引ID（17文字）または送信者のメールアドレス",
    "ko": "예: PayPal 거래 ID (17자) 또는 발신자 이메일",
    "hi": "उदा. PayPal लेनदेन ID (17 अक्षर) या प्रेषक का ईमेल"
  },
  "amountLabel": {
    "id": "Nominal",
    "en": "Amount",
    "ar": "المبلغ",
    "fr": "Montant",
    "de": "Betrag",
    "es": "Importe",
    "ru": "Сумма",
    "zh": "金额",
    "ja": "金額",
    "ko": "금액",
    "hi": "राशि"
  },
  "paidOnLabel": {
    "id": "Tanggal transfer",
    "en": "Transfer date",
    "ar": "تاريخ التحويل",
    "fr": "Date du virement",
    "de": "Überweisungsdatum",
    "es": "Fecha de transferencia",
    "ru": "Дата перевода",
    "zh": "转账日期",
    "ja": "送金日",
    "ko": "송금 날짜",
    "hi": "ट्रांसफर की तारीख"
  },
  "referenceLabel": {
    "id": "Referensi / catatan (opsional)",
    "en": "Reference / notes (optional)",
    "ar": "المرجع / الملاحظات (اختياري)",
    "fr": "Référence / notes (facultatif)",
    "de": "Referenz / Notizen (optional)",
    "es": "Referencia / notas (opcional)",
    "ru": "Ссылка / примечания (необязательно)",
    "zh": "参考 / 备注（可选）",
    "ja": "参照 / メモ（任意）",
    "ko": "참조 / 메모 (선택 사항)",
    "hi": "संदर्भ / नोट्स (वैकल्पिक)"
  },
  "referencePlaceholder": {
    "id": "mis. nama pengirim atau ID transaksi",
    "en": "e.g. sender name or transaction ID",
    "ar": "مثال: اسم المُرسِل أو معرّف المعاملة",
    "fr": "ex. nom de l'expéditeur ou ID de transaction",
    "de": "z. B. Absendername oder Transaktions-ID",
    "es": "p. ej. nombre del remitente o ID de transacción",
    "ru": "напр. имя отправителя или ID транзакции",
    "zh": "例如：汇款人姓名或交易编号",
    "ja": "例：送金者名または取引ID",
    "ko": "예: 송금인 이름 또는 거래 ID",
    "hi": "जैसे: प्रेषक का नाम या लेनदेन आईडी"
  },
  "sendConfirmation": {
    "id": "Kirim konfirmasi",
    "en": "Send confirmation",
    "ar": "إرسال التأكيد",
    "fr": "Envoyer la confirmation",
    "de": "Bestätigung senden",
    "es": "Enviar confirmación",
    "ru": "Отправить подтверждение",
    "zh": "发送确认",
    "ja": "確認を送信する",
    "ko": "확인 전송",
    "hi": "पुष्टि भेजें"
  },
  "confirmationSent": {
    "id": "Konfirmasi terkirim. Kami akan memverifikasinya dan mengaktifkan lencana Anda.",
    "en": "Confirmation sent. We will verify it and activate your badge.",
    "ar": "تم إرسال التأكيد. سنقوم بالتحقق منه وتفعيل شارتك.",
    "fr": "Confirmation envoyée. Nous allons la vérifier et activer votre badge.",
    "de": "Bestätigung gesendet. Wir werden sie prüfen und Ihr Abzeichen aktivieren.",
    "es": "Confirmación enviada. La verificaremos y activaremos tu insignia.",
    "ru": "Подтверждение отправлено. Мы проверим его и активируем ваш значок.",
    "zh": "确认已发送。我们将对其进行核实并激活您的徽章。",
    "ja": "確認が送信されました。確認の上、バッジを有効化いたします。",
    "ko": "확인이 전송되었습니다. 검토 후 배지를 활성화하겠습니다.",
    "hi": "पुष्टि भेज दी गई। हम इसे सत्यापित करके आपका बैज सक्रिय करेंगे।"
  },
  "confirmationFailed": {
    "id": "Konfirmasi tidak terkirim. Silakan coba lagi.",
    "en": "Confirmation not sent. Please try again.",
    "ar": "لم يتم إرسال التأكيد. يرجى المحاولة مرة أخرى.",
    "fr": "Confirmation non envoyée. Veuillez réessayer.",
    "de": "Bestätigung nicht gesendet. Bitte versuchen Sie es erneut.",
    "es": "Confirmación no enviada. Por favor, inténtalo de nuevo.",
    "ru": "Подтверждение не отправлено. Пожалуйста, попробуйте снова.",
    "zh": "确认未发送。请重试。",
    "ja": "確認が送信されませんでした。もう一度お試しください。",
    "ko": "확인이 전송되지 않았습니다. 다시 시도해 주세요.",
    "hi": "पुष्टि नहीं भेजी जा सकी। कृपया पुनः प्रयास करें।"
  },
  "tooManyPending": {
    "id": "Anda masih memiliki konfirmasi yang menunggu verifikasi. Mohon tunggu hingga diproses.",
    "en": "You still have confirmations awaiting verification. Please wait until they are processed.",
    "ar": "لا يزال لديك تأكيدات في انتظار التحقق. يرجى الانتظار حتى تتم معالجتها.",
    "fr": "Vous avez encore des confirmations en attente de vérification. Veuillez patienter jusqu'à leur traitement.",
    "de": "Sie haben noch Bestätigungen, die auf Überprüfung warten. Bitte warten Sie, bis diese bearbeitet werden.",
    "es": "Aún tienes confirmaciones pendientes de verificación. Por favor, espera hasta que sean procesadas.",
    "ru": "У вас ещё есть подтверждения, ожидающие проверки. Пожалуйста, подождите, пока они будут обработаны.",
    "zh": "您仍有确认正在等待审核。请等待处理完成。",
    "ja": "まだ確認中の確認事項があります。処理が完了するまでお待ちください。",
    "ko": "아직 검토 중인 확인이 있습니다. 처리될 때까지 기다려 주세요.",
    "hi": "आपकी कुछ पुष्टियाँ अभी भी सत्यापन की प्रतीक्षा में हैं। कृपया उनके संसाधित होने तक प्रतीक्षा करें।"
  },
  "myConfirmations": {
    "id": "Konfirmasi saya",
    "en": "My Confirmations",
    "ar": "تأكيداتي",
    "fr": "Mes Confirmations",
    "de": "Meine Bestätigungen",
    "es": "Mis Confirmaciones",
    "ru": "Мои Подтверждения",
    "zh": "我的确认",
    "ja": "私の確認",
    "ko": "내 확인",
    "hi": "मेरी पुष्टियाँ"
  },
  "statusAwaiting": {
    "id": "Menunggu verifikasi",
    "en": "Awaiting Verification",
    "ar": "في انتظار التحقق",
    "fr": "En Attente de Vérification",
    "de": "Warte auf Verifizierung",
    "es": "En Espera de Verificación",
    "ru": "Ожидает Проверки",
    "zh": "等待验证",
    "ja": "確認待ち",
    "ko": "인증 대기 중",
    "hi": "सत्यापन की प्रतीक्षा में"
  },
  "statusVerified": {
    "id": "Terverifikasi",
    "en": "Verified",
    "ar": "تم التحقق",
    "fr": "Vérifié",
    "de": "Verifiziert",
    "es": "Verificado",
    "ru": "Подтверждено",
    "zh": "已验证",
    "ja": "確認済み",
    "ko": "인증됨",
    "hi": "सत्यापित"
  },
  "statusRejected": {
    "id": "Ditolak",
    "en": "Rejected",
    "ar": "مرفوض",
    "fr": "Rejeté",
    "de": "Abgelehnt",
    "es": "Rechazado",
    "ru": "Отклонено",
    "zh": "已拒绝",
    "ja": "拒否済み",
    "ko": "거부됨",
    "hi": "अस्वीकृत"
  }
};
